import React, { Component } from "react";
import {
  Form,
  Input,
  DatePicker,
  Select,
  Modal,
  message,
  Checkbox,
  Button,
  Tabs,
  Row,
  Col,
  ColorPicker,
  Spin,
  Space,
  Image,
  Drawer,
  Upload,
} from "antd";
import addIcon from "../assets/images/NewDesign/plus-lg.svg";
import dayjs from "dayjs";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { StoreContext } from "../store/RootStore";
import { EyeOutlined } from "@ant-design/icons";
import DriversStore from "../store/DriversStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import VehicleStore from "../store/VehicleStore";
import axios from "axios";

import CompanyStore from "../store/CompanyStore";
import CountryStore from "../store/CountryStore";
import "./AddAccount.css";
import config from "../config";
import DriverAdd from "./DriverAdd";
import VehicleTitleBox from "./VehicleTitleBox";
// import { CloseOutlined } from "@ant-design/icons";
import VehicleInfoAwtlFormFields from "./Plugins/AddVehicle/VehicleInfoAwtlFormFields";
import { CloseOutlined, UploadOutlined } from "@ant-design/icons";
import VehicleInfoAwtlProFormFields from "./Plugins/AddVehicle/VehicleInfoAwtlProFormFields";
import { hasFeature } from "../utils/componentVisibility";
import { th } from "date-fns/locale";
import { feature } from "caniuse-lite";
import SensorMappingStore from "../store/SensorMappingStore";
import SensorMappingAdd from "./SensorMappingAdd";

const features = {
  sweeper: hasFeature("showSweeperOptions"),
  showspeedmileageoptions: hasFeature("showspeedmileageoptions"),
  waslVehicleField: hasFeature("waslVehicleField"),
  awtlplatenocondition: hasFeature("awtlplatenocondition"),
  sensorMappingDropdown: hasFeature("sensorMappingDropdown"),
};
const { Option } = Select;
const dateFormat = "YYYY-MM-DD";

const { TabPane } = Tabs;

const translationArray = {
  0: "٠",
  1: "١",
  2: "٢",
  3: "٣",
  4: "٤",
  5: "٥",
  6: "٦",
  7: "٧",
  8: "٨",
  9: "٩",
  A: "ا",
  B: "ب",
  J: "ح",
  D: "د",
  R: "ر",
  S: "س",
  X: "ص",
  T: "ط",
  E: "ع",
  G: "ق",
  K: "ك",
  L: "ل",
  Z: "م",
  N: "ن",
  H: "ه",
  U: "و",
  V: "ى",
  M: "م",
};

const convertToArabicPlate = (value = "") => {
  return value
    .toUpperCase()
    .split("")
    .map((char) => translationArray[char] || char)
    .join(" ");
};

class VehicleAdd2 extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      tabErrors: {},
      formError: false,

      loading: false,
      vehicleId: -1,
      vehiCalSpeed: false,
      companyId: "",
      fuelSensor: false,
      DriverId: false,
      loadSensor: false,
      temperatureSensor: false,
      rfid: false,
      pta: false,
      sfda: false,
      basic: false,
      driverId: "",

      timezoneId: Number(config.defaultTimezoneId),
      one: true,
      two: true,
      three: true,

      horizontalrectangle: false,
      verticalcylinder: false,
      horizontalcylinder: false,

      horizontalrectangle2: false,
      verticalcylinder2: false,
      horizontalcylinder2: false,

      horizontalrectangle3: false,
      verticalcylinder3: false,
      horizontalcylinder3: false,

      vehicleType: "",

      school: false,
      loadData: 0,

      colorHex: "",
      formatHex: "hex",

      icon: "",
      headWeight: "",
      imeiError: false,
      invoiceError: false,
      openDriverDetailsForm: false,
      tagIdShow: false,

      showtIdField: true,
      redfield: false,

      loadingSpin: false,

      disabledField: false,
      pulseFields: false,
      selectRules: false,
      mdvrFields: false,

      taxiFields: false,
      showAlertModal: false,
      iridiumField: false,
      supervisorlist: [],
      stationlist: [],
      customerlist: [],
      assettypelist: [],
      devicelist: [],
      hasTemperatureSensor: false,
      vehicleplate: "",
      openSensorMappingForm: false,
      sensorMappingId: "",
      plateNo: "",
    };
    this.driverStore = new DriversStore();
    this.vehicleStore = new VehicleStore();
    this.companyStore = new CompanyStore();
    this.sensorMappingStore = new SensorMappingStore();
    this.countryStore = new CountryStore();
  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setVehicleStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({ isadmin: this.props.getUserData().isadmin });

      // await this.driverStore.toGetDriverName(
      //   this.props.getUserData().userCompanyId
      // );

      await this.vehicleStore.getDriversList(
        this.props.getUserData().userCompanyId,
      );

      // this.driverStore.getVehicles(
      //   this.props.getUserData().userCompanyId
      // );
    }
    const vehicleId = this.props.vehicleIdForEdit;

    // if(features.awtlplatenocondition){
    //   console("inside plateno")
    //   const platenoawtl=this.state.companyId == 126 || this.state.companyId == 132 || this.state.companyId == 4741 ||this.props.getUserData().userId == 52370
    //   this.setState({vehicleplate:platenoawtl})
    //   console.log(this.state.vehicleplate,"vehile plate")
    // }

    if (vehicleId) {
      await this.filldata(vehicleId);
      this.setState({ vehicleId: vehicleId });

      if (features.awtlplatenocondition) {
        let platenoawtl =
          this.state.companyId == 126 ||
          this.state.companyId == 132 ||
          this.state.companyId == 4741 ||
          this.state.companyId == 3457 ||
          this.props.getUserData().userId == 52370 ||
          this.props.getUserData().userId == 31015;
        this.setState({ vehicleplate: platenoawtl });
      }
    }
    await this.countryStore.getCountry();
    await this.countryStore.getTimeZone();

    await this.vehicleStore.getPollingImeiData();

    await this.vehicleStore.getFuelCaliDetails();

    await this.vehicleStore.getSFDACategories();

    // if (config.pythonReport === 1) {
    //   await this.vehicleStore.getdevicebrand();
    // }

    await this.setState({ loadList: 1 });
  }

  filldata = async (vehicleId) => {
    await this.setState({ loadingSpin: true });
    // const getVehicleDetails = await this.vehicleStore.getVehicleData(vehicleId);
    // console.log(getVehicleDetails, "getVehicleDetails");
    const getVehicleDetails =
      await this.vehicleStore.getVehicleDataNode(vehicleId);
    let compData = {};
    compData.label = getVehicleDetails.companyName;
    compData.value = getVehicleDetails.companyId;
    await this.handleChange(compData);
    await this.setState({
      companyId: getVehicleDetails.companyId,
      vehicleId: getVehicleDetails.vehicleId,
    });
    const singleData = await this.companyStore.getCompanyDataById(
      getVehicleDetails.companyId,
    );
    await this.setState({ companyLable: singleData });


    if(features.sensorMappingDropdown){
      await this.sensorMappingStore.loadData({
        companyId: getVehicleDetails.companyId,
        deviceId: Number(getVehicleDetails.deviceId),
        offset: -1,
        limit: 50,
      });
    }

    // await this.driverStore.toGetDriverName(getVehicleDetails.companyId);
    // await this.vehicleStore.getDriversList(getVehicleDetails.companyId);

    // await this.vehicleStore.getVehicleRules(getVehicleDetails.companyId);

    await this.formRef.current.setFieldsValue({
      fid1: getVehicleDetails.Fid1,
      fid2: getVehicleDetails.Fid2,
      fid3: getVehicleDetails.Fid3,

      installationspace1: getVehicleDetails.InstallationSpace1,
      installationspace2: getVehicleDetails.InstallationSpace2,
      installationspace3: getVehicleDetails.InstallationSpace3,
      InstallationType: getVehicleDetails.InstallationType,
      nofueltank: getVehicleDetails.No_FuelTank,

      Sensor1: getVehicleDetails.Sensor1,
      Sensor2: getVehicleDetails.Sensor2,
      Sensor3: getVehicleDetails.Sensor3,
      addOn: getVehicleDetails.addOn,

      batteryExpire: getVehicleDetails.batteryExpire,
      branch: getVehicleDetails.branch,
      capacity: getVehicleDetails.capacity,
      ColorCode: getVehicleDetails.colorCode,
      comment: getVehicleDetails.comment,
      companyId: singleData,

      department: getVehicleDetails.department,
      deviceGroupId: getVehicleDetails.deviceGroupId,
      deviceId: getVehicleDetails.deviceId
        ? Number(getVehicleDetails.deviceId)
        : null,

      diffOdo: getVehicleDetails.diffOdo,
      DigInpt1: getVehicleDetails.digital_Input1,
      DigInpt2: getVehicleDetails.digital_Input2,
      DigInpt3: getVehicleDetails.digital_Input3,
      DigInpt4: getVehicleDetails.digital_Input4,
      AngInpt1: getVehicleDetails.analog_Input1,
      AngInpt2: getVehicleDetails.analog_Input2,
      AngInpt3: getVehicleDetails.analog_Input3,
      AngInpt4: getVehicleDetails.analog_Input4,

      distance: getVehicleDetails.distance,
      dname: getVehicleDetails.dname,
      downPayment: getVehicleDetails.downPayment,

      driverId: getVehicleDetails.driverId
        ? Number(getVehicleDetails.driverId)
        : null,

      emiDueDate: getVehicleDetails?.emiDueDate
        ? dayjs(getVehicleDetails.emiDueDate)
        : null,
      emptyWeight: getVehicleDetails.emptyWeight,

      expiryDate: getVehicleDetails?.expiryDate
        ? dayjs(getVehicleDetails?.expiryDate)
        : null,
      fuelConsumption: getVehicleDetails.fuelConsumption,
      minimumFineAmount: getVehicleDetails.minimumFineAmount,
      finePerMinute: getVehicleDetails.finePerMinute,

      fuelId1: getVehicleDetails.fuelId1,
      fuelId2: getVehicleDetails.fuelId2,
      fuel: getVehicleDetails.fuelType,
      full_imei: this.props.forCopy == 1 ? "" : getVehicleDetails.full_imei,
      mdvrfull_imei: getVehicleDetails.mdvrfull_imei,
      headWeight: getVehicleDetails.headWeight,

      highLimit1: getVehicleDetails.highLimit1,
      highLimit2: getVehicleDetails.highLimit2,
      highLimit3: getVehicleDetails.highLimit3,

      hourMeterReading: getVehicleDetails.hourMeterReading,
      hourMeterReading2: getVehicleDetails.hourMeterReading2,

      idleLimit: getVehicleDetails.idleLimit,
      installDate: getVehicleDetails?.installDate
        ? dayjs(getVehicleDetails?.installDate)
        : null,
      installedLocation: getVehicleDetails.installedLocation,
      installer: getVehicleDetails.installer,
      insuranceRenewal: getVehicleDetails?.insuranceRenewal
        ? dayjs(getVehicleDetails?.insuranceRenewal)
        : null,

      isCanbus: getVehicleDetails.isCanbus ? 1 : 0,
      isDelivery: getVehicleDetails.isDelivery,
      lastBatteryDate: getVehicleDetails?.lastBatteryDate
        ? dayjs(getVehicleDetails?.lastBatteryDate)
        : null,
      lastDistanceOil: getVehicleDetails.lastDistanceOil,
      lastDistanceService: getVehicleDetails.lastDistanceService,
      lastDistanceTire: getVehicleDetails.lastDistanceTire,
      lastExpiryDate: getVehicleDetails?.lastExpiryDate
        ? dayjs(getVehicleDetails?.lastExpiryDate)
        : null,
      oilchangeKm: getVehicleDetails.lastOil,

      lastoilchange: getVehicleDetails?.lastOilDate
        ? dayjs(getVehicleDetails?.lastOilDate)
        : null,
      lastservicedone: getVehicleDetails?.lastServiceDate
        ? dayjs(getVehicleDetails?.lastServiceDate)
        : null,
      tirechangeKm: getVehicleDetails.lastTire,
      lasttirechange: getVehicleDetails?.lastTireDate
        ? dayjs(getVehicleDetails?.lastTireDate)
        : null,
      machineservicehours: getVehicleDetails.machineServiceHours,
      manufactureYear: getVehicleDetails.manufactureYear,
      maxHoursPerDay: getVehicleDetails.maxHoursPerDay,

      maxVolt: getVehicleDetails.maxVolt,
      minVolt: getVehicleDetails.minVolt,
      mobileno: getVehicleDetails.mobileno,
      vehicleModel: getVehicleDetails.model,
      monthlyEmi: getVehicleDetails.monthlyEmi,

      mulkiyaRenewal: getVehicleDetails?.mulkiyaRenewal
        ? dayjs(getVehicleDetails?.mulkiyaRenewal)
        : null,
      noOfEmi: getVehicleDetails.noOfEmi,
      odometerReading: getVehicleDetails.odometerReading,
      ownership: getVehicleDetails.ownership,
      password: getVehicleDetails.password,
      taxiType: getVehicleDetails.taxiType,
      paymentType: getVehicleDetails.paymentType,
      permitExpiryDate: getVehicleDetails?.permitExpiryDate
        ? dayjs(getVehicleDetails?.permitExpiryDate)
        : null,
      nationalPermitExpiryDate: getVehicleDetails?.nationalPermitExpiryDate
        ? dayjs(getVehicleDetails?.nationalPermitExpiryDate)
        : null,
      pollutionExpiryDate: getVehicleDetails?.pollutionExpiryDate
        ? dayjs(getVehicleDetails?.pollutionExpiryDate)
        : null,
      plateType: getVehicleDetails.plateType
        ? parseInt(getVehicleDetails.plateType)
        : null,
      plateno: this.props.forCopy == 1 ? "" : getVehicleDetails.vehicleNo,
      region: getVehicleDetails.region,
      regularRunningHours: getVehicleDetails.regularRunningHours,
      renewalPrice: getVehicleDetails.renewalPrice,
      seater: getVehicleDetails.seater,
      sequenceNo: getVehicleDetails.sequenceNo,
      serviceexpireKm: getVehicleDetails.serviceexpire,
      vehiclesimno: this.props.forCopy == 1 ? "" : getVehicleDetails.simNo,
      speedlimit: getVehicleDetails.speedLimit,

      tId: getVehicleDetails.tId,
      tankdiameter1: getVehicleDetails.tankDiameter,
      tankdiameter2: getVehicleDetails.tankDiameter2,
      tankdiameter3: getVehicleDetails.tankDiameter3,
      tankheight1: getVehicleDetails.tankHeight,
      tankheight2: getVehicleDetails.tankHeight2,

      tankheight3: getVehicleDetails.tankHeight3,
      tanklength1: getVehicleDetails.tankLength,
      tanklength2: getVehicleDetails.tankLength2,
      tanklength3: getVehicleDetails.tankLength3,
      tankshape1: getVehicleDetails.tankShape,
      tankshape2: getVehicleDetails.tankShape2,
      tankshape3: getVehicleDetails.tankShape3,

      tankvolume: getVehicleDetails.tankVolume,
      tankwidth1: getVehicleDetails.tankWidth,
      tankwidth2: getVehicleDetails.tankWidth2,
      tankwidth3: getVehicleDetails.tankWidth3,
      tempId1: getVehicleDetails.tempId1,
      tempId2: getVehicleDetails.tempId2,
      tempId3: getVehicleDetails.tempId3,
      timezoneId: Number(getVehicleDetails.timezoneId),
      totalVehicleCost: getVehicleDetails.totalVehicleCost,

      // fuel: getVehicleDetails.type,
      username: getVehicleDetails.username,
      vehicleBrand: getVehicleDetails.vehicleBrand,
      vehicleId: getVehicleDetails.vehicleNo,
      vehicleName: this.props.forCopy == 1 ? "" : getVehicleDetails.vehicleName,
      vehicleNoArabic:
        this.props.forCopy == 1 ? "" : getVehicleDetails.vehicleNoArabic,

      vehiclePurchaseDate: getVehicleDetails.vehiclePurchaseDate
        ? dayjs(getVehicleDetails?.vehiclePurchaseDate)
        : null,
      vehicleType: getVehicleDetails.vehicleType,
      vehicleTypeNew: getVehicleDetails.vehicleTypeNew,
      weightFactor: getVehicleDetails.weightFactor,
      pollingimei: getVehicleDetails.pollingimei,
      renewedAt: getVehicleDetails.renewedAt,
      mobileno: getVehicleDetails.mobileno,
      attendantName: getVehicleDetails.attendantName,
      icon: getVehicleDetails.icon,
      rpm: getVehicleDetails.rpm,
      movingRPM: getVehicleDetails.movingRPM,
      idelRPM: getVehicleDetails.idelRPM,

      UDID: getVehicleDetails.UDID,
      UDID2: getVehicleDetails.UDID2,
      seatCapacity: getVehicleDetails.seatCapacity,
      noOfBaggage: getVehicleDetails.noOfBaggage,
      harshAcce: getVehicleDetails.harshAcce,
      harshBrack: getVehicleDetails.harshBrack,
      exIdeling: getVehicleDetails.exIdeling,
      speeding: getVehicleDetails.speeding,
      rpmExcess: getVehicleDetails.rpmExcess,
      inputdigital: getVehicleDetails.inputdigital,
      rule: getVehicleDetails.ruleId,
      speedmileage: getVehicleDetails.speedmileage
        ? Number(getVehicleDetails.speedmileage)
        : null,

      // ? getVehicleDetails.speedmileage
      // : Number(getVehicleDetails.speedmileage),
      mileage: parseFloat(getVehicleDetails.mileage),
      pulseCount: parseFloat(getVehicleDetails.pulseCount),
      speedConstant: parseFloat(getVehicleDetails.speedConstant),

      MDVR: getVehicleDetails.MDVR,
      cmsvssWebHost: getVehicleDetails.cmsvssWebHost,
      cmsvssWebPort: getVehicleDetails.cmsvssWebPort,
      cmsvssLoginServerPort: getVehicleDetails.cmsvssLoginServerPort,
      cmsvssPlaybachPort: getVehicleDetails.cmsvssPlaybachPort,
      cmsvssUserName: getVehicleDetails.cmsvssUserName,
      cmsvssPassword: getVehicleDetails.cmsvssPassword,

      fuelConsumption: getVehicleDetails.fuelConsumption,
      fuelCalibrationId: getVehicleDetails.fuelCalibrationId,
      chassisNo: getVehicleDetails.chassisNo,
      technicianName: getVehicleDetails.technicianName,
      remark: getVehicleDetails.remark,

      lastServiceHours: getVehicleDetails.lastServiceHours,
      iridium_full_imei: getVehicleDetails.iridium_full_imei,
      
      companyLable: "",
      invoiceNo: getVehicleDetails.invoiceNo,
      simType: getVehicleDetails.simType,
      weightSensorAnalogNumber: getVehicleDetails.weightSensorAnalogNumber,
      weightInKilogramsHalfLoad: getVehicleDetails.weightInKilogramsHalfLoad,
      weightInKilogramsFullLoad: getVehicleDetails.weightInKilogramsFullLoad,
      mlVoltageEmptyVehicle: getVehicleDetails.mlVoltageEmptyVehicle,
      mlVoltageHalfLoad: getVehicleDetails.mlVoltageHalfLoad,
      mlVoltageFullLoad: getVehicleDetails.mlVoltageFullLoad,
      hasTemperatureSensor: getVehicleDetails.hasTemperatureSensor,
      hasHumiditySensor: getVehicleDetails.hasHumiditySensor,
      temperatureAnalogNumber: getVehicleDetails.temperatureAnalogNumber,
      humidityAnalogNumber: getVehicleDetails.humidityAnalogNumber,

      // deviceBrandName: getVehicleDetails.deviceBrandId,
      deviceBrandName:
        getVehicleDetails.deviceBrandId &&
        Number(getVehicleDetails.deviceBrandId) !== 0
          ? [getVehicleDetails.deviceBrandId]
          : [],
      assetTypeCustomName:
        getVehicleDetails.assetTypeCustomId &&
        Number(getVehicleDetails.assetTypeCustomId) !== 0
          ? [getVehicleDetails.assetTypeCustomId]
          : [],
      supervisorName:
        getVehicleDetails.supervisorName &&
        Number(getVehicleDetails.supervisorName) !== 0
          ? [getVehicleDetails.supervisorName]
          : [],
      stationName:
        getVehicleDetails.stationName &&
        Number(getVehicleDetails.stationName) !== 0
          ? [getVehicleDetails.stationName]
          : [],
      customerName:
        getVehicleDetails.customerName &&
        Number(getVehicleDetails.customerName) !== 0
          ? [getVehicleDetails.customerName]
          : [],

      baseLocation: getVehicleDetails.baseLocation,
      odometerReading: getVehicleDetails.odometerReading,
      templateId: getVehicleDetails.templateId,
    });

    this.setState({
      hasTemperatureSensor: Boolean(getVehicleDetails.hasTemperatureSensor),
      hasHumiditySensor: Boolean(getVehicleDetails.hasHumiditySensor),
      icon: getVehicleDetails.icon,
    });

    // console.log("hasTemperatureSensor",this.state.hasTemperatureSensor)
    // console.log("hasHumiditySensor",this.state.hasHumiditySensor)

    if (getVehicleDetails.No_FuelTank == 1) {
      this.setState({ one: true });
      this.setState({ two: false });
      this.setState({ three: false });
    } else if (getVehicleDetails.No_FuelTank == 2) {
      this.setState({ one: true });
      this.setState({ two: true });
      this.setState({ three: false });
    } else if (getVehicleDetails.No_FuelTank == 3) {
      this.setState({ one: true });
      this.setState({ two: true });
      this.setState({ three: true });
    }

    if (getVehicleDetails.tankShape == "Horizontal Rectangle") {
      this.setState({ horizontalrectangle: true });
    } else if (getVehicleDetails.tankShape == "Vertical Cylinder") {
      this.setState({ verticalcylinder: true });
    } else if (getVehicleDetails.tankShape == "Horizontal Cylinder") {
      this.setState({ horizontalcylinder: true });
    }

    if (getVehicleDetails.tankShape2 == "Horizontal Rectangle") {
      this.setState({ horizontalrectangle2: true });
    } else if (getVehicleDetails.tankShape2 == "Vertical Cylinder") {
      this.setState({ verticalcylinder2: true });
    } else if (getVehicleDetails.tankShape2 == "Horizontal Cylinder") {
      this.setState({ horizontalcylinder2: true });
    }

    if (getVehicleDetails.tankShape3 == "Horizontal Rectangle") {
      this.setState({ horizontalrectangle3: true });
    } else if (getVehicleDetails.tankShape3 == "Vertical Cylinder") {
      this.setState({ verticalcylinder3: true });
    } else if (getVehicleDetails.tankShape3 == "Horizontal Cylinder") {
      this.setState({ horizontalcylinder3: true });
    }

    if (getVehicleDetails.InstallationType == "PTA") {
      this.setState({ loadSensor: true });
    }

    const addonStr = getVehicleDetails.addOn;

    if (getVehicleDetails.addOn) {
      const addonArray = addonStr?.split(",");

      addonArray[0] === "1" && this.setState({ fuelSensor: true });
      addonArray[2] === "3" && this.setState({ DriverId: true });
      addonArray[3] === "4" && this.setState({ rfid: true });
      addonArray[1] === "2" && this.setState({ temperatureSensor: true });
      // addonArray[4] === "5" && this.setState({ rfid: true });
    }
    this.setState({ vehicleType: getVehicleDetails.vehicleType });
    if (getVehicleDetails.vehicleType === 3) {
      this.setState({ school: true });
    }

    if (getVehicleDetails.vehicleType === 30) {
      await this.vehicleStore.getTaxiType();
      this.setState({ taxiFields: true });
    }

    if ([6, 13, 18].includes(getVehicleDetails.deviceId)) {
      this.setState({ mdvrFields: true });
    }

    if (getVehicleDetails.deviceId == 22) {
      this.setState({ iridiumField: true });
    }

    if (
      getVehicleDetails.speedmileage == 2 ||
      getVehicleDetails.speedmileage == "Pulse"
    ) {
      this.setState({ pulseFields: true });
    }
    if (
      (this.props.getUserData().isadmin === 1 ||
        this.props.getUserData().isadmin === 0) &&
      this.props.vehicleIdForEdit
    ) {
      this.setState({ disabledField: true });
      if (features.awtlplatenocondition) {
        let platenoawtl =
          this.state.companyId == 126 ||
          this.state.companyId == 132 ||
          this.state.companyId == 4741 ||
          this.state.companyId == 3457 ||
          this.props.getUserData().userId == 52370 ||
          this.props.getUserData().userId == 31015;
        this.setState({ vehicleplate: platenoawtl });
      }
    }

    this.setState({ loadData: 1, loadingSpin: false });
  };

  validateNumberAndDecimal = (value, field) => {
    const value1 = value.replace(/[^0-9.,]+/g, "");

    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  handleSelectAllRules = async (e) => {
    var arr = [];
    this.setState({ selectRules: e.target.checked });

    if (e.target.checked) {
      const data = await this.vehicleStore?.vehicleRules.map((option) =>
        arr.push(option.ruleId),
      );

      this.formRef.current.setFieldsValue({ rule: arr });
    } else {
      arr = [];
      this.formRef.current.setFieldsValue({ rule: arr });
    }
  };

  closeDriverModal = () => {
    this.setState({ openDriverDetailsForm: false });
  };

  closeSensorMappingModal = () => {
    this.setState({ openSensorMappingForm: false });
  };

  responseMsg = async (response) => {
    // const DriverName = await this.driverStore.toGetDriverName(
    //   this.state.companyId
    // );

    // await this.vehicleStore.getDriversList(this.state.companyId);
    // console.log(response, "response");
    if (response.success == "S") {
      message.success(response.message);
      // await this.driverStore.toGetDriverName(this.state.companyId);
      await this.vehicleStore.getDriversList(this.state.companyId);
      await this.formRef.current.setFieldsValue({
        driverId: Number(response?.data.driverId),
        // driverId:response.data.name
      });

      await this.setState({ openDriverDetailsForm: false });
      // await this.formRef.current?.resetFields();
    } else if (response.success === "F5000") {
      response.errors.map((value) => {
        message.error(this.context.translate(value["username"]));
      });
    }

    this.setState({ loadData: 1 });
    this.setState({ loading: false });

    await this.companyStore.getCompanyDataById(this.state.companyId);

    await this.setState({ loadData: 1 });
  };

  sensorMappingResponseMsg = async (resp) => {
    console.log("resp",resp)
    if (resp?.data.success === "S") {
      console.log("Loading templates");

      message.success(resp?.data.message);

      await this.sensorMappingStore.loadData({
        companyId: this.state.companyId,
        deviceId: resp?.data?.deviceId,
        offset: -1,
        limit: 50,
      });


      const sensorMappingId = resp?.data?.templateId; // or resp.data.id

      this.formRef.current.setFieldsValue({
        templateId: sensorMappingId,
      });

      this.setState({
        // sensorMappingId,
        openSensorMappingForm: false,
      });
    }else{
      console.log("error");
      this.setState({openSensorMappingForm: false})
    }

    await this.setState({ loadData: 1 });
    
  };

  selectDriver = async (value) => {
    await this.setState({ driverId: value });
    this.formRef.current.setFieldsValue({ driverId: value });
  };

  showPulseFields = (val) => {
    if (val == 2) {
      this.setState({ pulseFields: true });
    } else {
      this.setState({ pulseFields: false });
    }
  };

  onVehicleDetailsSubmit = async (values) => {
    this.setState({ loading: true });
    await this.formRef.current.validateFields();
    const vehicle = {
      ...values,
      tokenId: "",
      companyId: this.state.companyId,
      vehicleType: this.state.vehicleType,
      vehicleId: this.props.forCopy == 1 ? "" : this.state.vehicleId,
      userId: this.props.getUserData().userId,
      ColorCode: this.state.colorHex,
      isCanbus: values?.isCanbus ? 1 : 0,
      isDelivery: values?.isDelivery,
      installDate: values?.installDate
        ? values?.installDate?.format(dateFormat)
        : null,
      expiryDate: values?.expiryDate
        ? values?.expiryDate?.format(dateFormat)
        : null,
      mulkiyaRenewal: values?.mulkiyaRenewal
        ? values?.mulkiyaRenewal?.format(dateFormat)
        : null,
      insuranceRenewal: values?.insuranceRenewal
        ? values?.insuranceRenewal?.format(dateFormat)
        : null,
      lastservicedone: values?.lastservicedone
        ? values?.lastservicedone?.format(dateFormat)
        : null,
      lastoilchange: values?.lastoilchange
        ? values?.lastoilchange?.format(dateFormat)
        : null,
      lasttirechange: values?.lasttirechange
        ? values?.lasttirechange?.format(dateFormat)
        : null,
      lastBatteryDate: values?.lastBatteryDate
        ? values?.lastBatteryDate?.format(dateFormat)
        : null,
      lastBatteryChange: values?.lastBatteryChange
        ? values?.lastBatteryChange?.format(dateFormat)
        : null,
      emiDueDate: values?.emiDueDate
        ? values?.emiDueDate?.format(dateFormat)
        : null,
      vehiclePurchaseDate: values?.vehiclePurchaseDate
        ? values?.vehiclePurchaseDate?.format(dateFormat)
        : null,
      permitExpiryDate: values?.permitExpiryDate
        ? values?.permitExpiryDate?.format(dateFormat)
        : null,
      nationalPermitExpiryDate: values?.nationalPermitExpiryDate
        ? values?.nationalPermitExpiryDate?.format(dateFormat)
        : null,
      pollutionExpiryDate: values?.pollutionExpiryDate
        ? values?.pollutionExpiryDate?.format(dateFormat)
        : null,

      addOn: [
        this.state.fuelSensor ? "1" : "0",
        this.state.temperatureSensor ? "2" : "0",
        this.state.DriverId ? "3" : "0",
        this.state.rfid ? "4" : "0",
      ],
      icon: this.state.icon,
      isadmin: this.props.getUserData().isadmin,
      isaddformValidation: this.props.canCreate("wasladdinvoicevalidation"),
      iseditformValidation: this.props.canUpdate("wasleditinvoicevalidation"),
      stationName: Array.isArray(values.stationName)
        ? values.stationName[0]
        : values.stationName,
      supervisorName: Array.isArray(values.supervisorName)
        ? values.supervisorName[0]
        : values.supervisorName,
      customerName: Array.isArray(values.customerName)
        ? values.customerName[0]
        : values.customerName,
      assetTypeCustomName: Array.isArray(values.assetTypeCustomName)
        ? values.assetTypeCustomName[0]
        : values.assetTypeCustomName,
      deviceBrandName: (() => {
        const val = Array.isArray(values.deviceBrandName)
          ? values.deviceBrandName[0]
          : values.deviceBrandName;
        return val;
      })(),
    };

    const data = { tokenId: "", vehicle: vehicle };

    // console.log(data, "data");
    const resp = await this.vehicleStore.addData(data);

    await this.props.response(resp);
    if (
      this.context.translate(resp.data?.errors[0]?.full_imei) ===
      "IMEI NO. Already Exist for Asset"
    ) {
      // this.setState({ imeiError:"IMEI NO. Already Exist for Asset"});
      this.setState({
        imeiError: (
          <div style={{ marginTop: 5, color: "red", fontSize: 12 }}>
            IMEI NO. Already Exist for Asset
          </div>
        ),
      });
    } else if (resp.data?.errors?.[0]?.invoiceNo) {
      this.setState({
        invoiceError: (
          <div style={{ marginTop: 5, color: "red", fontSize: 12 }}>
            {resp.data.errors[0].invoiceNo}
          </div>
        ),
      });

      message.error(resp.data.errors[0].invoiceNo);
    }

    this.setState({ loading: false });
  };

  async handleChange(comp) {

    await this.setState({ companyId: comp.value });
    if (!this.props.vehicleIdForEdit) {
      this.context.viewStateStore.setVehicleStates({ companyId: comp.value });
    }

    await this.setState({
      companyLable: { label: comp.label, value: comp.value },
    });


    await this.vehicleStore.getDriversList(comp.value);
    await this.vehicleStore.getDevices();

    if (config.pythonReport === 1) {
      await this.vehicleStore.getSupervisorname(comp.value);
      await this.setState({ supervisorlist: this.vehicleStore.supervisor });
      await this.setState({ stationlist: this.vehicleStore.station });
      await this.setState({ customerlist: this.vehicleStore.customer });
      await this.setState({ assettypelist: this.vehicleStore.assettype });
    }

    if(features.sensorMappingDropdown){
      this.sensorMappingStore.sensorMappingData = [];
    }

    this.setState({loadData:1})

  }

  async handleSearch() {
    await this.vehicleStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      usercompanyId: this.props.getUserData().userCompanyId,
    });
    await this.setState({ loadList: 1 });
  }

  addOn = (value) => {
    for (let i = 0; i < value.length; i++) {
      if (value[i] === 1) {
        this.setState({ fuelSensor: true });
      } else if (value[i] === 3) {
        this.setState({ DriverId: true });
      } else if (value[i] === 2) {
        this.setState({ temperatureSensor: true });
      } else if (value[i] === 4) {
        this.setState({ rfid: true });
      } else {
        this.setState({ fuelSensor: false });
        this.setState({ DriverId: false });

        this.setState({ temperatureSensor: false });
        this.setState({ rfid: false });
      }
    }
  };

  noOfFuelTanks = (value) => {
    if (value === 1) {
      this.setState({ one: true });
      this.setState({ two: false });
      this.setState({ three: false });
    } else if (value === 2) {
      this.setState({ one: true });
      this.setState({ two: true });
      this.setState({ three: false });
    } else if (value === 3) {
      this.setState({ one: true });
      this.setState({ two: true });
      this.setState({ three: true });
    } else {
      this.setState({ one: false });
      this.setState({ two: false });
      this.setState({ three: false });
    }
  };
  tankShape1 = (value) => {
    if (value === "Horizontal Rectangle") {
      this.setState({ horizontalrectangle: true });
      this.setState({ verticalcylinder: false });
      this.setState({ horizontalcylinder: false });
    } else if (value === "Vertical Cylinder") {
      this.setState({ verticalcylinder: true });
      this.setState({ horizontalrectangle: false });
      this.setState({ horizontalcylinder: false });
    } else if (value === "Horizontal Cylinder") {
      this.setState({ horizontalcylinder: true });
      this.setState({ verticalcylinder: false });
      this.setState({ horizontalrectangle: false });
    } else {
      this.setState({ verticalcylinder: false });
      this.setState({ horizontalrectangle: false });
      this.setState({ horizontalcylinder: false });
    }
  };

  tankShape2 = (value) => {
    if (value === "Horizontal Rectangle") {
      this.setState({ horizontalrectangle2: true });
      this.setState({ horizontalcylinder2: false });
      this.setState({ verticalcylinder2: false });
    } else if (value === "Vertical Cylinder") {
      this.setState({ verticalcylinder2: true });
      this.setState({ horizontalrectangle2: false });
      this.setState({ horizontalcylinder2: false });
    } else if (value === "Horizontal Cylinder") {
      this.setState({ horizontalcylinder2: true });
      this.setState({ verticalcylinder2: false });
      this.setState({ horizontalrectangle2: false });
    } else {
      this.setState({ verticalcylinder2: false });
      this.setState({ horizontalrectangle2: false });
      this.setState({ horizontalcylinder2: false });
    }
  };

  tankShape3 = (value) => {
    if (value === "Horizontal Rectangle") {
      this.setState({ horizontalrectangle3: true });
      this.setState({ horizontalcylinder3: false });
      this.setState({ verticalcylinder3: false });
    } else if (value === "Vertical Cylinder") {
      this.setState({ verticalcylinder3: true });
      this.setState({ horizontalrectangle3: false });
      this.setState({ horizontalcylinder3: false });
    } else if (value === "Horizontal Cylinder") {
      this.setState({ horizontalcylinder3: true });
      this.setState({ verticalcylinder3: false });
      this.setState({ horizontalrectangle3: false });
    } else {
      this.setState({ verticalcylinder3: false });
      this.setState({ horizontalrectangle3: false });
      this.setState({ horizontalcylinder3: false });
    }
  };

  handleVTypeChange = async (value, option) => {
    // console.log("value", value, option);
    await this.setState({ vehicleType: option.data });
    await this.formRef.current.setFieldsValue({ vehicleTypeNew: option.value });
  };
  onSelectSchool = (value) => {
    if (value === "SchoolBus") {
      this.setState({ school: true });
    } else {
      this.setState({ school: false });
    }
  };

  onSelectTaxi = async (value) => {
    if (value === "Taxi") {
      this.setState({ taxiFields: true });
      await this.vehicleStore.getTaxiType();
      this.setState({ loadData: 1 });
    } else {
      this.setState({ taxiFields: false });
    }
  };

  validateFieldsValue = (value, field) => {
    const value1 = value.replace(/[^0-9.]*/g, "");

    if (value1) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  validateYearField = (value, field) => {
    const value1 = value.replace(/[^0-9+]*/g, "");
    if (value1) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }

    if (field === "full_imei" && this.state.imeiError) {
      this.setState({ imeiError: null });
    }
    if (field === "invoiceNo" && this.state.invoiceError) {
      this.setState({ invoiceError: null });
    }
  };

  getTypeByCategory = async (categoryId) => {
    const data = await this.vehicleStore.getTypeByCategory(categoryId);
    await this.setState({ loadData: 1 });
  };

  getWeightsUsingTid = async (tId) => {
    const data = await this.vehicleStore.getWeightBytId(tId);

    await this.formRef.current.setFieldsValue({
      emptyWeight: data.trailerEmptyWeight,
    });

    const total = parseFloat(this.state.headWeight) + data.trailerEmptyWeight;

    await this.setState({ loadData: 1 });
  };

  warning = () => {
    Modal.warning({
      title: this.context.translate("_FLEET_ALERT_"),
      content: this.context.translate("_INSTALLATION_TYPE_MESSAGE_"),
    });
  };

  handleChangeHex = (color) => {
    const colorHex = typeof color === "string" ? color : color.toHexString();
    this.setState({ colorHex });
  };

  handleFormatChangeHex = (formatHex) => {
    this.setState({ formatHex });
  };
  handleFormError = (err) => {
    const { errorFields } = err;

    const tabErrors = {};

    errorFields.forEach(({ name }) => {
      const [fieldName] = name;
      const tabFieldMappings = {
        companyId: 1,
        plateno: 1,
        vehicleTypeNew: 1,
        timezoneId: 1,
        installDate: 1,
        renewalPrice: 1,
        pollingimei: 1,
        vehiclesimno: 1,
        full_imei: 1,
        vehicleNoArabic: 1,
        installer: 1,
        installedLocation: 1,
        invoiceNo: 1,
      };
      const tab = tabFieldMappings[fieldName];

      if (tab) {
        tabErrors[tab] = true;
      }
    });

    this.setState({ tabErrors });
  };

  handleNextClick = async () => {
    const form = this.formRef.current;

    if (form) {
      try {
        if (this.state.activeTab === "1") {
          const fieldsToValidate = [
            "companyId",
            "plateno",
            "vehicleTypeNew",
            "timezoneId",
            "installDate",
            "renewalPrice",
            "pollingimei",
            "vehiclesimno",
            "full_imei",
            "vehicleNoArabic",
            "deviceId",
            "InstallationType",
            "sequenceNo",
            "plateType",
            "weightFactor",
            "headWeight",
            "invoiceNo",
            "odometerReading",
          ];

          if (features?.waslVehicleField) {
            fieldsToValidate.push(
              "simType",
              "installer",
              "installedLocation",
              "emptyWeight",
              "weightInKilogramsFullLoad",
              "weightSensorAnalogNumber",
              "mlVoltageEmptyVehicle",
              "mlVoltageFullLoad",
              "temperatureAnalogNumber",
              "humidityAnalogNumber",
              "deviceBrandName",
            );
          }

          await form.validateFields(fieldsToValidate);
        } else {
          // Validate all fields in other tabs
          await form.validateFields();
        }

        const { activeTab } = this.state;
        const nextTab = String(Number(activeTab) + 1);
        this.setState({ activeTab: nextTab });
      } catch (err) {
        console.error("Form Validation Error:", err);
        message.error(
          this.context.translate("_FLEET_GROUP_GROUPDETAIL_ERRORMSG_"),
        );

        this.setState({ formError: true });
      }
    }
  };
  handleTabChange = (key) => {
    this.setState({
      activeTab: key,
      formError: false,
    });
  };

  handleBackClick = () => {
    const { activeTab } = this.state;
    const previousTab = String(Number(activeTab) - 1);

    this.setState({ activeTab: previousTab });
  };

  getUploadData = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    if (fileinfo?.success == "S") {
      await this.setState({ icon: fileinfo.data });
    }
    fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
    this.vehicleStore.setLogoFromDb(fileUp.fileList);

    this.setState({ update: 1 });
  };

  validatePhoneNumber = (value, field) => {
    const value1 = value.replace(/[^0-9+]*/g, "");

    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  closeModal = () => {
    this.props.closeModal();
  };

  // handleDeviceFields = (val) => {
  //   if (val == 6) {
  //     this.setState({ mdvrFields: true });
  //   } else {
  //     this.setState({ mdvrFields: false });
  //   }
  // };

  handleDeviceFields = async (val) => {

    if(features.sensorMappingDropdown){
      await this.sensorMappingStore.loadData({
        companyId: this.state.companyId,
        deviceId: val,
        offset: -1,
        limit: 50,
      });
    }

    if (val == 22) {
      this.setState({ iridiumField: true });
    } else {
      this.setState({ iridiumField: false });
    }
    if ([6, 13, 18].includes(val)) {
      this.setState({ mdvrFields: true });
    } else {
      this.setState({ mdvrFields: false });
    }
  };

  handleCheckboxChange = (checked, field) => {
    this.setState({ [field]: checked });
  };

  handleCheckboxValues = (checked, field) => {
    this.setState({ [field]: checked });
  };

  installationType = (value) => {
    if (value === "PTA") {
      this.setState({ pta: true, loadSensor: true });
      this.setState({ sfda: false });
      this.setState({ basic: false });
      this.setState({ showtIdField: true });
    } else if (value === "SFDA") {
      this.setState({ sfda: true });
      this.setState({ pta: false, loadSensor: true });
      this.setState({ basic: false });
      this.setState({ showtIdField: true });
    } else if (value === "Basic") {
      this.setState({ pta: false });
      this.setState({ sfda: false });
      this.setState({ loadSensor: false });
      this.setState({ basic: true });
      this.setState({ showtIdField: true });
    }
  };

  handleLoadSensorCheckbox = (newState) => {
    this.setState(newState);
  };
  showTabTitle = () => {
    const { activeTab } = this.state;

    if (activeTab === "1") {
      return this.context.translate("_ASSET_DETAILS_");
    } else if (activeTab === "2") {
      return this.context.translate("_MAINTENANCE_DETAILS_");
    } else if (activeTab === "3") {
      return this.context.translate("_PERIPHERALS_");
    }
  };

  uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      const formData = new FormData();
      formData.append("icon", file);
      formData.append("fileType", "vehicleicon");
      formData.append("fieldName", "icon");

      const response = await axios.post(
        // config.baseURL + this.companyStore.fileUploadUrl,
        config.NodeUrl + "/vehicle/fileUpload",
        formData,
        {
          headers: {
            token: this.state.token,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress({ percent });
          },
        },
      );

      onSuccess(response.data);
    } catch (error) {
      onError(error);
    }
  };

  showTabDesc = () => {
    const { activeTab } = this.state;
    if (activeTab === "1") {
      return this.context.translate("_ASSET_DETAILS_DESC_");
    } else if (activeTab === "2") {
      return this.context.translate("_MAINTENANCE_DETAILS_DESC_");
    } else if (activeTab === "3") {
      return this.context.translate("_PERIPHERALS_DESC_");
    }
  };
  render() {
    const { colorHex, formatHex } = this.state;

    return (
      <>
        <div style={{ padding: 0, height: "100%" }}>
          <div style={{ height: "100%" }}>
            <Spin
              spinning={this.state.loadingSpin}
              wrapperClassName="spinClass"
              fullscreen
            >
              <Form
                ref={this.formRef}
                labelCol={{
                  span: 20,
                }}
                layout="vertical"
                onFinish={this.onVehicleDetailsSubmit}
                onFinishFailed={this.handleFormError}
                className="accountFormClass"
                name="nest-message"
                initialValues={{ speedmileage: 1, weightSensorAnalogNumber: 1 }}
              >
                <div style={{ height: "100%" }}>
                  <div
                    style={{
                      background: "#07163D",
                      padding: "15px",
                      height: "10%",
                    }}
                  >
                    <h3 className="tab-title">{this.showTabTitle()}</h3>
                    <p className="tab-description">{this.showTabDesc()}</p>
                  </div>
                  <Tabs
                    className="accountTabs"
                    style={{ height: "90%" }}
                    activeKey={this.state.activeTab}
                    onChange={this.handleTabChange}
                  >
                    <TabPane
                      tab={
                        <span
                          className={
                            this.state.tabErrors["1"] && "validation-failed"
                          }
                        >
                          <Button
                            type="text"
                            style={{
                              background:
                                this.state.activeTab === "1"
                                  ? " rgba(255, 255, 255, 0.30)"
                                  : "rgb(7, 22, 61)",
                              border: "none",
                              borderRadius: "0px",
                            }}
                          >
                            {this.context.translate("_ASSET_DETAILS_")}
                          </Button>
                        </span>
                      }
                      key="1"
                    >
                      <div
                        style={{
                          overflowY: "scroll",
                          height: "90%",
                          paddingInlineStart: "20px",
                        }}
                      >
                        <VehicleTitleBox title={this.context.translate("")}>
                          <Row gutter={16}>
                            <Col span={12}>
                              {(this.props.getUserData().isadmin === -1 ||
                                this.props.getUserData().isadmin === 3) && (
                                <Form.Item
                                  className="uploadCompany"
                                  name="companyId"
                                  label={
                                    <span>
                                      {this.context.translate("_ACCOUNT_")}{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </span>
                                  }
                                  required={false}
                                  rules={[
                                    {
                                      required: true,
                                      message: `${this.context.translate(
                                        "_ACCOUNT_",
                                      )} ${this.context.translate(
                                        "_IS_REQUIRED_",
                                      )}`,
                                    },
                                  ]}
                                >
                                  <CompanyAutocomplete
                                    onChange={(value) => {
                                      this.handleChange(value);
                                    }}
                                    companyId={this.state.companyId}
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                              )}

                              {this.props.getUserData().isadmin !== 1 &&
                                this.props.getUserData().isadmin !== 0 && (
                                  <>
                                    <Form.Item
                                      className="uploadCompany"
                                      name="installer"
                                      label={
                                        <span>
                                          {this.context.translate(
                                            "_INSTALLER_",
                                          )}{" "}
                                          {features?.waslVehicleField && (
                                            <span style={{ color: "red" }}>
                                              {" "}
                                              *
                                            </span>
                                          )}
                                        </span>
                                      }
                                      required={false}
                                      rules={[
                                        {
                                          required: features?.waslVehicleField,
                                          message: `${this.context.translate(
                                            "_INSTALLER_",
                                          )} ${this.context.translate(
                                            "_IS_REQUIRED_",
                                          )}`,
                                        },
                                      ]}
                                    >
                                      <Input />
                                    </Form.Item>

                                    <Form.Item
                                      name="installedLocation"
                                      label={
                                        <span>
                                          {this.context.translate(
                                            "_INSATALLED_LOCATION_",
                                          )}{" "}
                                          {features?.waslVehicleField && (
                                            <span style={{ color: "red" }}>
                                              {" "}
                                              *
                                            </span>
                                          )}
                                        </span>
                                      }
                                      required={false}
                                      rules={[
                                        {
                                          required: features?.waslVehicleField,
                                          message: `${this.context.translate(
                                            "_INSATALLED_LOCATION_",
                                          )} ${this.context.translate(
                                            "_IS_REQUIRED_",
                                          )}`,
                                        },
                                      ]}
                                    >
                                      <Input />
                                    </Form.Item>
                                  </>
                                )}
                              {(this.props.getUserData().isadmin == -1 ||
                                this.props.getUserData().isadmin == 3) && (
                                <Form.Item
                                  className="uploadCompany"
                                  name="deviceId"
                                  required={false}
                                  labelInValue
                                  rules={[
                                    {
                                      required: true,
                                      message: `${this.context.translate(
                                        "_DEVICE_",
                                      )} ${this.context.translate(
                                        "_IS_REQUIRED_",
                                      )}`,
                                    },
                                  ]}
                                  label={
                                    <span>
                                      {this.context.translate("_DEVICE_")}{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </span>
                                  }
                                >
                                  <Select
                                    onSelect={(value) =>
                                      this.handleDeviceFields(value)
                                    }
                                  >
                                    {this.vehicleStore?.devices.map((val) => {
                                      return (
                                        <Option
                                          key={val.deviceId}
                                          value={val.deviceId}
                                        >
                                          {val.deviceName}
                                        </Option>
                                      );
                                    })}
                                  </Select>
                                </Form.Item>
                              )}

                              {this.state.iridiumField && (
                                <Form.Item
                                  className="uploadCompany"
                                  name="iridium_full_imei"
                                  label={this.context.translate(
                                    "_IRIDIUM_IMEI_",
                                  )}
                                >
                                  <Input />
                                </Form.Item>
                              )}
                            </Col>
                            <Col span={12}>
                              {this.props.getUserData().isadmin !== 1 &&
                                this.props.getUserData().isadmin !== 0 && (
                                  <Form.Item
                                    className="uploadCompany"
                                    name="timezoneId"
                                    label={
                                      <span>
                                        {this.context.translate(
                                          "_FLEET_COMPANY_COMPANYDETAIL_TIME_",
                                        )}{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </span>
                                    }
                                    required={false}
                                    rules={[
                                      {
                                        required: true,
                                        message: `${this.context.translate(
                                          "_FLEET_COMPANY_COMPANYDETAIL_TIME_",
                                        )} ${this.context.translate(
                                          "_IS_REQUIRED_",
                                        )}`,
                                      },
                                    ]}
                                    initialValue={this.state.timezoneId}
                                  >
                                    <Select
                                      showSearch
                                      placeholder="Select TimeZone"
                                      filterOption={(inputValue, option) => {
                                        return (
                                          option.children
                                            .toLowerCase()
                                            .indexOf(
                                              inputValue.toLowerCase(),
                                            ) >= 0
                                        );
                                      }}
                                    >
                                      {this.countryStore?.timeZones.map(
                                        (country) => {
                                          return (
                                            <Option
                                              value={Number(country.timezoneId)}
                                            >
                                              {country.abbr}
                                            </Option>
                                          );
                                        },
                                      )}
                                    </Select>
                                  </Form.Item>
                                )}

                              <Form.Item
                                className="uploadCompany"
                                label={
                                  <span>
                                    {this.context.translate(
                                      "_DRIVER_NAME_",
                                    )}{" "}
                                  </span>
                                }
                              >
                                <Space.Compact
                                  style={{
                                    width: "100%",
                                    gap: "10px",
                                  }}
                                >
                                  <Form.Item
                                    name="driverId"
                                    className="uploadCompany"
                                    label={this.context.translate(
                                      "_DRIVER_NAME_",
                                    )}
                                    noStyle
                                  >
                                    <Select
                                      className="selectDriver"
                                      showSearch
                                      placeholder={this.context.translate(
                                        "_SELECT_DRIVER_",
                                      )}
                                      filterOption={(inputValue, option) => {
                                        return (
                                          option.children
                                            .toLowerCase()
                                            .indexOf(
                                              inputValue.toLowerCase(),
                                            ) >= 0
                                        );
                                      }}
                                      value={this.state.driverId}
                                      onSelect={this.selectDriver}
                                    >
                                      {this.vehicleStore?.getDriverName?.map(
                                        (driver) => {
                                          return (
                                            <Option
                                              value={parseInt(driver.driverId)}
                                            >
                                              {driver.name}
                                            </Option>
                                          );
                                        },
                                      )}
                                    </Select>
                                  </Form.Item>
                                  <Form.Item noStyle>
                                    <Button
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "35px",
                                        backgroundColor: "#2196F3",
                                        padding: "0px 13px",
                                      }}
                                      onClick={() => {
                                        this.setState({
                                          openDriverDetailsForm: true,
                                        });
                                      }}
                                    >
                                      <Image
                                        style={{
                                          width: "13px",
                                          height: "13px",
                                        }}
                                        src={addIcon}
                                      ></Image>
                                    </Button>
                                  </Form.Item>
                                </Space.Compact>
                              </Form.Item>

                              {/* {!this.props.vehicleIdForEdit && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Form.Item
                                    name="rule"
                                    label={this.context.translate("_RULE_")}
                                    style={{ width: "80%" }}
                                  >
                                    <Select
                                      className="select-dropdown"
                                      mode="multiple"
                                      // className="search-field"
                                      maxTagCount={"responsive"}
                                      options={this.vehicleStore?.vehicleRules}
                                      fieldNames={{
                                        label: "name",
                                        value: "ruleId",
                                      }}
                                    />
                                  </Form.Item>

                                  <Form.Item label=" ">
                                    <Checkbox
                                      checked={this.state.selectRules}
                                      onChange={(e) => {
                                        this.handleSelectAllRules(e);
                                      }}
                                    >
                                      {this.context.translate("_ALL_")}{" "}
                                    </Checkbox>
                                  </Form.Item>
                                </div>
                              )} */}

                              <Form.Item
                                className="uploadCompany"
                                name="vehicleTypeNew"
                                label={
                                  <span>
                                    {this.context.translate("_VEHICLE_TYPE_")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                }
                                required={false}
                                rules={[
                                  {
                                    required: true,
                                    message: `${this.context.translate(
                                      "_VEHICLE_TYPE_",
                                    )} ${this.context.translate(
                                      "_IS_REQUIRED_",
                                    )}`,
                                  },
                                ]}
                              >
                                <Select
                                  onChange={(value) => {
                                    this.onSelectSchool(value.value);
                                    this.onSelectTaxi(value.value);
                                  }}
                                  onSelect={this.handleVTypeChange}
                                  labelInValue
                                  options={[
                                    {
                                      value: "Truck",

                                      label: this.context.translate("_TRUCK_"),
                                      data: "1",
                                    },
                                    {
                                      value: "Car",

                                      label: this.context.translate("_car_"),
                                      data: "2",
                                    },
                                    {
                                      value: "SchoolBus",

                                      label:
                                        this.context.translate("_SCHOOL_BUS_"),
                                      data: "3",
                                    },
                                    {
                                      value: "PickUp",

                                      label: this.context.translate("_PICKUP_"),
                                      data: "4",
                                    },
                                    {
                                      value: "2Ton PickUp",

                                      label:
                                        this.context.translate("_2TON_PICKUP_"),
                                      data: "29",
                                    },
                                    {
                                      value: "3Ton PickUp",

                                      label:
                                        this.context.translate("_3TON_PICKUP_"),
                                      data: "5",
                                    },
                                    {
                                      value: "5Ton PickUp",

                                      label:
                                        this.context.translate("_5TON_PICKUP_"),
                                      data: "6",
                                    },
                                    {
                                      value: "10Ton PickUp",

                                      label:
                                        this.context.translate(
                                          "_10TON_PICKUP_",
                                        ),
                                      data: "7",
                                    },
                                    {
                                      value: "Crane",

                                      label: this.context.translate("_CRANE_"),
                                      data: "8",
                                    },
                                    {
                                      value: "JCB",

                                      label: this.context.translate("_JCB_"),
                                      data: "9",
                                    },
                                    {
                                      value: "Van",

                                      label: this.context.translate("_VAN_"),
                                      data: "10",
                                    },
                                    {
                                      value: "Hiace",

                                      label: this.context.translate("_HIACE_"),
                                      data: "11",
                                    },
                                    {
                                      value: "Urvan",

                                      label: this.context.translate("_URVAN_"),
                                      data: "12",
                                    },
                                    {
                                      value: "Tanker",

                                      label: this.context.translate("_TANKER_"),
                                      data: "13",
                                    },
                                    {
                                      value: "Bulldozer",

                                      label:
                                        this.context.translate("_BULLDOZER_"),
                                      data: "14",
                                    },
                                    {
                                      value: "Dumper",

                                      label: this.context.translate("_DUMPER_"),
                                      data: "15",
                                    },
                                    {
                                      value: "Reefer",

                                      label: this.context.translate("_REEFER_"),
                                      data: "16",
                                    },
                                    {
                                      value: "Shovel",

                                      label: this.context.translate("_SHOVEL_"),
                                      data: "17",
                                    },
                                    {
                                      value: "Excavator",

                                      label:
                                        this.context.translate("_EXCAVATOR_"),
                                      data: "18",
                                    },
                                    {
                                      value: "Trailer",
                                      label: this.context.translate("_TAILER_"),

                                      data: "19",
                                    },
                                    {
                                      value: "Forklif",

                                      label:
                                        this.context.translate("_FORKLIF_"),
                                      data: "20",
                                    },
                                    {
                                      value: "Bobcat",

                                      label: this.context.translate("_BOBCAT_"),
                                      data: "21",
                                    },
                                    {
                                      value: "Roller",

                                      label: this.context.translate("_ROLLER_"),
                                      data: "22",
                                    },
                                    {
                                      value: "Canter",

                                      label: this.context.translate("_CANTER_"),
                                      data: "23",
                                    },
                                    {
                                      value: "Mini Bus",

                                      label:
                                        this.context.translate("_MINIBUS_"),
                                      data: "24",
                                    },
                                    {
                                      value: "Tourist Bus",

                                      label:
                                        this.context.translate("_TOURIST_BUS_"),
                                      data: "25",
                                    },
                                    {
                                      value: "Boom Loader",

                                      label:
                                        this.context.translate("_BOOM_LOADER_"),
                                      data: "26",
                                    },
                                    {
                                      value: "Generator",

                                      label:
                                        this.context.translate("_GENERATOR_"),
                                      data: "27",
                                    },
                                    {
                                      value: "Hilux",

                                      label: this.context.translate("_HILUX_"),
                                      data: "28",
                                    },
                                    {
                                      value: "Motorcycle",

                                      label:
                                        this.context.translate("_MOTORCYCLE_"),
                                      data: "29",
                                    },
                                    {
                                      value: "Taxi",

                                      label: this.context.translate("_TAXI_"),
                                      data: "30",
                                    },
                                    {
                                      value: "SmartPhone",
                                      label:
                                        this.context.translate("_SMART_PHONE_"),
                                      data: "31",
                                    },
                                    {
                                      value: "Sweeper",
                                      label:
                                        this.context.translate("_SWEEPER_"),
                                      data: "32",
                                    },
                                  ]}
                                />
                              </Form.Item>
                              {this.state.vehicleType == "3" && (
                                <Form.Item
                                  className="uploadCompany"
                                  name="password"
                                  label={this.context.translate("_PASSWORD_")}
                                  // label={
                                  //   <span>
                                  //     {this.context.translate("_PASSWORD_")}{" "}
                                  //     <span style={{ color: "red" }}>*</span>
                                  //   </span>
                                  // }
                                  // required={false}
                                  // rules={[
                                  //   {
                                  //     required: true,
                                  //     message: `${this.context.translate(
                                  //       "_PASSWORD_"
                                  //     )} ${this.context.translate(
                                  //       "_IS_REQUIRED_"
                                  //     )}`,
                                  //   },
                                  // ]}
                                >
                                  <Input />
                                </Form.Item>
                              )}

                              {this.state.taxiFields && (
                                <Form.Item
                                  name="taxiType"
                                  label={this.context.translate("_TAXI_TYPE_")}
                                >
                                  <Select placeholder="Select Taxi Type">
                                    {this.vehicleStore?.taxiTypes.map((val) => (
                                      <Option
                                        key={val.vehicleTypeId}
                                        value={val.vehicleTypeId}
                                      >
                                        {val.vehicleTaxiType}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              )}
                              {this.state.school && (
                                <>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="seater"
                                    label={this.context.translate("_SERATER_")}
                                  >
                                    <Input />
                                  </Form.Item>

                                  <Form.Item
                                    className="uploadCompany"
                                    name="mobileno"
                                    label={this.context.translate(
                                      "_ATTENDANT_MOBILE_NO_",
                                    )}
                                    rules={[
                                      {
                                        pattern: /^(\d{7}|\d{10})$/,
                                        message: "Enter 7 or 10 Digit Number",
                                      },
                                    ]}
                                  >
                                    <Input
                                      onChange={(e) =>
                                        this.validatePhoneNumber(
                                          e.target.value,
                                          "mobileno",
                                        )
                                      }
                                    />
                                  </Form.Item>

                                  <Form.Item
                                    className="uploadCompany"
                                    name="attendantName"
                                    label={this.context.translate(
                                      "_ATTENDANT_NAME_",
                                    )}
                                  >
                                    <Input />
                                  </Form.Item>
                                </>
                              )}
                            </Col>
                          </Row>
                        </VehicleTitleBox>
                        {this.props.getUserData().isadmin !== 1 &&
                          this.props.getUserData().isadmin !== 0 && (
                            <VehicleTitleBox
                              title={this.context.translate("_DEVICE_DETAILS_")}
                            >
                              <Row gutter={16}>
                                <Col span={12}>
                                  {this.props.getUserData().isadmin !== 1 &&
                                    this.props.getUserData().isadmin !== 0 && (
                                      <>
                                        <Form.Item
                                          className="uploadCompany"
                                          name="pollingimei"
                                          label={this.context.translate(
                                            "_POLLING_IMEI_",
                                          )}
                                        >
                                          <Select
                                            showSearch
                                            placeholder="Search IMEI"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                              option?.children
                                                ?.toString()
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                            }
                                            onSelect={(val, record) =>
                                              this.formRef.current.setFieldsValue(
                                                {
                                                  full_imei: record.children,
                                                },
                                              )
                                            }
                                          >
                                            {this.vehicleStore?.getpollimie.map(
                                              (val) => (
                                                <Option
                                                  key={val.pollId}
                                                  value={val.pollId}
                                                >
                                                  {val.imei}
                                                </Option>
                                              ),
                                            )}
                                          </Select>
                                        </Form.Item>

                                        <Form.Item
                                          className="uploadCompany"
                                          name="full_imei"
                                          label={
                                            <span>
                                              {this.context.translate("_IMEI_")}{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </span>
                                          }
                                          required={false}
                                          rules={[
                                            {
                                              required: true,
                                              message: `${this.context.translate(
                                                "_IMEI_",
                                              )} ${this.context.translate(
                                                "_IS_REQUIRED_",
                                              )}`,
                                            },
                                          ]}
                                          help={
                                            this.state.imeiError
                                              ? this.state.imeiError
                                              : null
                                          }
                                        >
                                          <Input
                                            status={
                                              this.state.imeiError
                                                ? "error"
                                                : null
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;

                                              if (this.state.imeiError) {
                                                this.setState({
                                                  imeiError: null,
                                                });
                                              }

                                              // this.validateYearField(
                                              //   value,
                                              //   "full_imei"
                                              // );
                                            }}
                                          />
                                        </Form.Item>

                                        {features.sensorMappingDropdown && (
                                          <Form.Item
                                            className="uploadCompany"
                                            label={
                                              <span>
                                                {this.context.translate("_SENSOR_MAPPING_")}{" "}
                                              </span>
                                            }
                                          >
                                            <Space.Compact
                                              style={{
                                                width: "100%",
                                                gap: "10px",
                                              }}
                                            >
                                              <Form.Item
                                                className="uploadCompany"
                                                name="templateId"
                                                noStyle
                                              >
                                                <Select
                                                  showSearch
                                                  placeholder={this.context.translate("_SENSOR_MAPPING_")}
                                                  optionFilterProp="label"
                                                  filterOption={(input, option) =>
                                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                                  }
                                                >
                                                  {this.sensorMappingStore?.sensorMappingData?.map((item) => (
                                                    <Select.Option
                                                      key={item.id}
                                                      value={item.id}
                                                      label={item.templateName}
                                                    >
                                                      {item.templateName}
                                                    </Select.Option>
                                                  ))}
                                                </Select>
                                              </Form.Item>

                                              <Form.Item noStyle shouldUpdate>
                                                {({ getFieldValue }) =>
                                                  getFieldValue("templateId") ? (
                                                    <Button
                                                      style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "35px",
                                                        backgroundColor: "#2196F3",
                                                        padding: "0px",
                                                        color: "#fff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                      }}
                                                      icon={<EyeOutlined />}
                                                      onClick={() => {
                                                        console.log("sensorMappingId",this.formRef.current.getFieldValue("templateId"),"openSensorMappingForm",this.state.openSensorMappingForm)
                                                        this.setState({
                                                          openSensorMappingForm: true,
                                                          sensorMappingId: this.formRef.current.getFieldValue("templateId"),
                                                        });
                                                      }}
                                                    />
                                                  ) : null
                                                }
                                              </Form.Item>
                                            </Space.Compact>
                                          </Form.Item>
                                        )}
                                      </>
                                    )}        

                                  {this.state.mdvrFields && (
                                    <>
                                      <Form.Item
                                        className="uploadCompany"
                                        name="cmsvssWebHost"
                                        label="CMS/VSS Web Host"
                                      >
                                        <Input />
                                      </Form.Item>

                                      <Form.Item
                                        className="uploadCompany"
                                        name="MDVR"
                                        label="MDVR Server"
                                      >
                                        <Select placeholder="Select Type">
                                          {this.vehicleStore?.mdvrServer?.map(
                                            (val) => {
                                              return (
                                                <Option
                                                  key={val.name}
                                                  value={val.name}
                                                >
                                                  {val.name}
                                                </Option>
                                              );
                                            },
                                          )}
                                        </Select>
                                      </Form.Item>

                                      <Form.Item
                                        className="uploadCompany"
                                        name="cmsvssWebPort"
                                        label="CMS/VSS Web Port"
                                      >
                                        <Input />
                                      </Form.Item>

                                      <Form.Item
                                        className="uploadCompany"
                                        name="cmsvssLoginServerPort"
                                        label="CMS/VSS Login Server Port"
                                      >
                                        <Input />
                                      </Form.Item>
                                    </>
                                  )}

                                  {this.state.taxiFields && (
                                    <>
                                      <Form.Item
                                        className="uploadCompany"
                                        name="UDID"
                                        label={this.context.translate(
                                          "_SCREEN_UDID_",
                                        )}
                                      >
                                        <Input />
                                      </Form.Item>

                                      <Form.Item
                                        className="uploadCompany"
                                        name="UDID2"
                                        label={this.context.translate(
                                          "_SCREEN_UDID2_",
                                        )}
                                      >
                                        <Input />
                                      </Form.Item>
                                    </>
                                  )}
                                </Col>
                                <Col span={12}>
                                  {this.props.getUserData().isadmin !== 1 &&
                                    this.props.getUserData().isadmin !== 0 && (
                                      <>
                                        <Form.Item
                                          className="uploadCompany"
                                          name="vehiclesimno"
                                          label={
                                            <span>
                                              {this.context.translate(
                                                "_SIM_NO_",
                                              )}{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </span>
                                          }
                                          required={false}
                                          rules={[
                                            {
                                              required: true,
                                              message: `${this.context.translate(
                                                "_SIM_NO_",
                                              )} ${this.context.translate(
                                                "_IS_REQUIRED_",
                                              )}`,
                                            },
                                          ]}
                                        >
                                          <Input
                                            onChange={(e) =>
                                              this.validateYearField(
                                                e.target.value,
                                                "vehiclesimno",
                                              )
                                            }
                                          />
                                        </Form.Item>

                                        {features.waslVehicleField && (
                                          <Form.Item
                                            className="uploadCompany"
                                            name="simType"
                                            label={
                                              <span>
                                                {this.context.translate(
                                                  "_SIM_VENDOR_",
                                                )}{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </span>
                                            }
                                            required={false}
                                            rules={[
                                              {
                                                required: true,
                                                message: `${this.context.translate(
                                                  "_SIM_VENDOR_",
                                                )} ${this.context.translate(
                                                  "_IS_REQUIRED_",
                                                )}`,
                                              },
                                            ]}
                                          >
                                            <Select
                                              // labelInValue
                                              options={[
                                                {
                                                  value: 1,
                                                  label:
                                                    this.context.translate(
                                                      "_MOBILY_",
                                                    ),
                                                },
                                                {
                                                  value: 2,
                                                  label:
                                                    this.context.translate(
                                                      "_ZAIN_",
                                                    ),
                                                },
                                                {
                                                  value: 3,
                                                  label:
                                                    this.context.translate(
                                                      "_STC_",
                                                    ),
                                                },
                                                {
                                                  value: 4,
                                                  label:
                                                    this.context.translate(
                                                      "_LEBARA_",
                                                    ),
                                                },
                                                {
                                                  value: 5,
                                                  label:
                                                    this.context.translate(
                                                      "_OTHER_",
                                                    ),
                                                },
                                              ]}
                                            />
                                          </Form.Item>
                                        )}

                                        <Form.Item
                                          name="mdvrfull_imei"
                                          label={this.context.translate(
                                            "_MDVR_IMEI_",
                                          )}
                                          className="uploadCompany"
                                        >
                                          <Input />
                                        </Form.Item>
                                        {this.state.mdvrFields && (
                                          <>
                                            <Form.Item
                                              className="uploadCompany"
                                              name="cmsvssPlaybachPort"
                                              label="CCMS/VSS Login Playback Port"
                                            >
                                              <Input />
                                            </Form.Item>

                                            <Form.Item
                                              className="uploadCompany"
                                              name="cmsvssUserName"
                                              label="CMS/VSS Username"
                                            >
                                              <Input />
                                            </Form.Item>

                                            <Form.Item
                                              className="uploadCompany"
                                              name="cmsvssPassword"
                                              label="CMS/VSS Password"
                                            >
                                              <Input />
                                            </Form.Item>
                                          </>
                                        )}

                                        {this.state.taxiFields && (
                                          <>
                                            <Form.Item
                                              className="uploadCompany"
                                              name="password"
                                              label={this.context.translate(
                                                "_FLEET_LOGIN_PASSWORDLBL_",
                                              )}
                                            >
                                              <Input />
                                            </Form.Item>
                                          </>
                                        )}
                                      </>
                                    )}
                                </Col>
                              </Row>
                            </VehicleTitleBox>
                          )}

                        <VehicleTitleBox
                          title={this.context.translate("_ASSET_DETAILS_")}
                        >
                          <Row gutter={16}>
                            <Col span={12}>
                              <Form.Item
                                className="uploadCompany"
                                name="plateno"
                                label={
                                  <span>
                                    {this.context.translate("_PLATE_NO_")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                }
                                required={false}
                                rules={[
                                  {
                                    required: !(
                                      this.props.getUserData().isadmin == 1 ||
                                      this.props.getUserData().isadmin == 0
                                    ),
                                    message: `${this.context.translate(
                                      "_PLATE_NO_",
                                    )} ${this.context.translate("_IS_REQUIRED_")}`,
                                  },
                                ]}
                              >
                                {/* disabled={this.props.vehicleIdForEdit ? !this.state.vehicleplate : false} */}
                                <Input
                                  disabled={
                                    this.props.getUserData().isadmin == 1 ||
                                    this.props.getUserData().isadmin == 0
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    const plateNo = e.target.value;

                                    this.setState({ plateNo: plateNo });

                                    this.formRef.current?.setFieldsValue({
                                      vehicleNoArabic:
                                        convertToArabicPlate(plateNo),
                                    });
                                  }}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="vehicleName"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_VEHICLENAME_",
                                )}
                              >
                                <Input />
                              </Form.Item>
                              {this.props.getUserData().isadmin !== 1 &&
                                this.props.getUserData().isadmin !== 0 && (
                                  <Form.Item
                                    className="uploadCompany"
                                    name="speedmileage"
                                    initialValue={1}
                                    label={
                                      <span>
                                        {this.context.translate(
                                          "_SPEEDMILEAGE_",
                                        )}{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </span>
                                    }
                                    required={false}
                                    rules={[{ required: true }]}
                                  >
                                    <Select
                                      disabled={
                                        this.props.getUserData().isadmin ===
                                          1 ||
                                        this.props.getUserData().isadmin === 0
                                          ? true
                                          : false
                                      }
                                      options={[
                                        { label: "GPS", value: 1 },
                                        { label: "Pulse", value: 2 },
                                        { label: "Cango", value: 3 },
                                        ...(features.showspeedmileageoptions
                                          ? [
                                              {
                                                label: "CAN Distance",
                                                value: 4,
                                              },
                                              {
                                                label: "Can Distance High RES",
                                                value: 5,
                                              },
                                            ]
                                          : []),
                                      ]}
                                      onSelect={(val) => {
                                        this.showPulseFields(val);
                                      }}
                                    />
                                  </Form.Item>
                                )}

                              {this.state.pulseFields && (
                                <>
                                  {" "}
                                  <Form.Item
                                    className="uploadCompany"
                                    name="speedConstant"
                                    label={
                                      <span>
                                        {this.context.translate(
                                          "_SPEED_CONSTANT_",
                                        )}{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </span>
                                    }
                                    required={false}
                                    rules={[
                                      {
                                        required: true,
                                        message: `${this.context.translate(
                                          "_SPEED_CONSTANT_",
                                        )} ${this.context.translate(
                                          "_IS_REQUIRED_",
                                        )}`,
                                      },
                                    ]}
                                  >
                                    <Input />
                                  </Form.Item>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="pulseCount"
                                    label={
                                      <span>
                                        {this.context.translate(
                                          "_PULSE_COUNT_PER_CIRCLE_",
                                        )}{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </span>
                                    }
                                    required={false}
                                    rules={[
                                      {
                                        required: true,
                                        message: `${this.context.translate(
                                          "_PULSE_COUNT_PER_CIRCLE_",
                                        )} ${this.context.translate(
                                          "_IS_REQUIRED_",
                                        )}`,
                                      },
                                    ]}
                                  >
                                    <Input />
                                  </Form.Item>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="mileage"
                                    label={
                                      <span>
                                        {this.context.translate(
                                          "_MILEAGE_PER_CIRCLE_",
                                        )}{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </span>
                                    }
                                    required={false}
                                    rules={[
                                      {
                                        required: true,
                                        message: `${this.context.translate(
                                          "_MILEAGE_PER_CIRCLE_",
                                        )} ${this.context.translate(
                                          "_IS_REQUIRED_",
                                        )}`,
                                      },
                                    ]}
                                  >
                                    <Input />
                                  </Form.Item>{" "}
                                </>
                              )}

                              <Form.Item
                                className="uploadCompany"
                                name="comment"
                                label={this.context.translate(
                                  "_FLEET_CREATEROUTE_ROUTEADD_COMMENT_",
                                )}
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                name="ownership"
                                label={this.context.translate(
                                  "_VEHICLE_OWNERSHIP_",
                                )}
                                className="uploadCompany"
                              >
                                <Select
                                  options={[
                                    {
                                      label: this.context.translate("_OWN_"),

                                      value: "Own",
                                    },
                                    {
                                      label: this.context.translate("_RENTED_"),
                                      value: "Rented",
                                    },
                                  ]}
                                />
                              </Form.Item>

                              <Form.Item
                                name="chassisNo"
                                label={this.context.translate(
                                  "_CHASSIS_NUMBER_",
                                )}
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="vehicleModel"
                                label={this.context.translate(
                                  "_VEHICLE_MODEL_",
                                )}
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="vehiclePurchaseDate"
                                label={this.context.translate(
                                  "_VEHICLE_PURCHASE_DATE_",
                                )}
                                rules={[{ type: Date }]}
                              >
                                <DatePicker
                                  style={{ width: "100%", height: "40px" }}
                                  format={dateFormat}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="downPayment"
                                label={this.context.translate("_DOWN_PAYMENT_")}
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="noOfEmi"
                                label={this.context.translate("_NO_OF_EMI_")}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "noOfEmi",
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                className="uploadCompany"
                                name="vehicleNoArabic"
                                label={
                                  <span>
                                    {this.context.translate(
                                      "ARABIC_VEHICLE_NO_",
                                    )}{" "}
                                  </span>
                                }
                                required={false}
                                // rules={[
                                //   {
                                //     required: !(
                                //       this.props.getUserData().isadmin == 1 ||
                                //       this.props.getUserData().isadmin == 0
                                //     ),
                                //     message: `${this.context.translate(
                                //       "ARABIC_VEHICLE_NO_"
                                //     )} ${this.context.translate("_IS_REQUIRED_")}`,
                                //   },
                                // ]}
                              >
                                <Input
                                  disabled={
                                    this.props.getUserData().isadmin == 1 ||
                                    this.props.getUserData().isadmin == 0
                                      ? true
                                      : false
                                  }
                                  style={{
                                    direction: "rtl",
                                  }}
                                />
                              </Form.Item>

                              <Form.Item
                                name="isDelivery"
                                label={this.context.translate(
                                  "_VEHICLE_ACTIVITY_",
                                )}
                              >
                                <Select>
                                  <Select.Option value={1}>
                                    {this.context.translate("_DELIVERY_")}
                                  </Select.Option>
                                </Select>
                              </Form.Item>

                              <Form.Item
                                name="idleLimit"
                                className="uploadCompany"
                                label={
                                  <span>
                                    {this.context.translate("_MAX_IDLE_LIMIT_")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                }
                                required={false}
                                initialValue={20}
                                rules={[
                                  {
                                    required: true,
                                    message: `${this.context.translate(
                                      "_MAX_IDLE_LIMIT_",
                                    )} ${this.context.translate(
                                      "_IS_REQUIRED_",
                                    )}`,
                                  },
                                ]}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "idleLimit",
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                name="speedlimit"
                                className="uploadCompany"
                                label={
                                  <span>
                                    {this.context.translate("_SPEED_LIMIT_")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                }
                                required={false}
                                initialValue={100}
                                rules={[
                                  {
                                    required: true,
                                    message: `${this.context.translate(
                                      "_SPEED_LIMIT_",
                                    )} ${this.context.translate(
                                      "_IS_REQUIRED_",
                                    )}`,
                                  },
                                ]}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "speedlimit",
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="vehicleBrand"
                                label={this.context.translate(
                                  "_VEHICLE_BRAND_",
                                )}
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="ColorCode"
                                label={this.context.translate(
                                  "_VEHICLE_COLOR_",
                                )}
                                initialValue={"FFFFFF"}
                              >
                                <ColorPicker
                                  style={{ width: "100%", height: "40px" }}
                                  format={formatHex}
                                  color={colorHex}
                                  onChange={this.handleChangeHex}
                                  onFormatChange={this.handleFormatChangeHex}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="manufactureYear"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_MANUFACTURE_",
                                )}
                              >
                                <Input
                                  placeholder={this.context.translate(
                                    "_FLEET_VEHICLE_VEHICLEDETAIL_MANUFACTURE_",
                                  )}
                                  onChange={(e) =>
                                    this.validateYearField(
                                      e.target.value,
                                      "manufactureYear",
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="totalVehicleCost"
                                label={this.context.translate(
                                  "_TOTAL_VEHICLE_COST_",
                                )}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "totalVehicleCost",
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="monthlyEmi"
                                label={this.context.translate("_MONTHLY_EMI_")}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "monthlyEmi",
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="emiDueDate"
                                label={this.context.translate("_EMI_DUE_DATE_")}
                                rules={[{ type: Date }]}
                              >
                                <DatePicker
                                  style={{ width: "100%", height: "40px" }}
                                  format={dateFormat}
                                />
                              </Form.Item>
                            </Col>

                            <VehicleInfoAwtlFormFields
                              vehicleStore={this.vehicleStore}
                              This={this.state}
                              isadmin={this.props.getUserData()}
                              installationType={this.installationType}
                              getTypeByCategory={this.getTypeByCategory}
                              validateFieldsValue={this.validateFieldsValue}
                              getWeightsUsingTid={this.getWeightsUsingTid}
                              formRef={this.formRef}
                              handleCheckboxChange={this.handleCheckboxValues}
                              warning={this.warning}
                              handleLoadSensorCheckbox={
                                this.handleLoadSensorCheckbox
                              }
                              waslVehicleField={features.waslVehicleField}
                              onTemperatureChange={(checked) => {
                                this.setState({
                                  hasTemperatureSensor: checked,
                                });

                                if (!checked) {
                                  this.formRef.current?.setFieldsValue({
                                    temperatureAnalogNumber: undefined,
                                  });
                                }
                              }}
                              onHumidityChange={(checked) => {
                                this.setState({ hasHumiditySensor: checked });

                                if (!checked) {
                                  this.formRef.current?.setFieldsValue({
                                    humidityAnalogNumber: undefined,
                                  });
                                }
                              }}
                              hasTemperatureSensor={
                                this.state.hasTemperatureSensor
                              }
                              hasHumiditySensor={this.state.hasHumiditySensor}
                            />
                            <VehicleInfoAwtlProFormFields
                              vehicleStore={this.vehicleStore}
                              supervisorlist={this.state.supervisorlist}
                              stationlist={this.state.stationlist}
                              customerlist={this.state.customerlist}
                              assettypelist={this.state.assettypelist}
                              devicelist={this.vehicleStore.devicebrand}
                              This={this.state}
                              isadmin={this.props.getUserData()}
                              invoiceNumber={this.invoiceNumber}
                              formRef={this.formRef}
                              invoiceError={this.state.invoiceError}
                              waslVehicleField={features.waslVehicleField}
                              loadSensor={this.state.loadSensor}
                            />

                            {config.pythonReport === 1 && (
                              <Form.Item
                                className="formCheckboxCss"
                                name="icon"
                                label=" "
                                // label={this.context.translate("_FLEET_DASHBORD_NEWPOI_PHOTO_")}
                                //  valuePropName="fileList"
                                style={{ marginTop: "14px" }}
                                getValueFromEvent={this.normFile}
                              >
                                <Upload
                                  style={{ backgroundColor: "black" }}
                                  name="icon"
                                  //    action={
                                  //      config.baseURL +
                                  //      "/index.php?c=company&a=fileupload"
                                  //    }
                                  listType="picture"
                                  data={{
                                    fileType: "vehicleicon",
                                    fieldName: "icon",
                                  }}
                                  onChange={this.getUploadData}
                                  customRequest={(options) =>
                                    this.uploadFunction(options)
                                  }
                                  onRemove={async () => {
                                    await this.setState({
                                      photo: "",
                                      fileList: [],
                                    });
                                    await this.vehicleStore.setLogoFromDb([]);
                                  }}
                                  maxCount={1}
                                  // fileList={this.companyStore.logoFromDb}
                                  // onRemove={this.removeImage}
                                  {...this.vehicleStore.logoFromDb}
                                >
                                  <Button
                                    className="imgupload"
                                    icon={<UploadOutlined />}
                                  >
                                    {this.context.translate(
                                      "_CLICK_TO_UPLOAD_",
                                    )}
                                  </Button>
                                </Upload>
                              </Form.Item>
                            )}
                          </Row>
                        </VehicleTitleBox>

                        {this.props.getUserData().isadmin !== 1 &&
                          this.props.getUserData().isadmin !== 0 && (
                            <VehicleTitleBox
                              title={this.context.translate("_FINANCIALS_")}
                            >
                              <Row gutter={16}>
                                <Col span={12}>
                                  {this.props.getUserData().isadmin !== 1 &&
                                    this.props.getUserData().isadmin !== 0 && (
                                      <>
                                        <Form.Item
                                          className="uploadCompany"
                                          name="paymentType"
                                          label={
                                            <span>
                                              {this.context.translate(
                                                "_SUBSCRIPTION_TYPE_",
                                              )}{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </span>
                                          }
                                          required={false}
                                          initialValue={"Yearly"}
                                          rules={[
                                            {
                                              required: true,
                                              message: `${this.context.translate(
                                                "_PAYMENT_TYPE_",
                                              )} ${this.context.translate(
                                                "_IS_REQUIRED_",
                                              )}`,
                                            },
                                          ]}
                                        >
                                          <Select
                                            disabled={this.state.disabledField}
                                            options={[
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_MONTHLY_",
                                                  ),
                                                value: "Monthly",
                                              },

                                              {
                                                label:
                                                  this.context.translate(
                                                    "_YEARLY_",
                                                  ),
                                                value: "Yearly",
                                              },
                                            ]}
                                            onChange={(value) => {
                                              if (value == "Monthly") {
                                                this.formRef.current.setFieldsValue(
                                                  {
                                                    expiryDate: dayjs().add(
                                                      1,
                                                      "month",
                                                    ),
                                                  },
                                                );
                                              } else if (value == "Yearly") {
                                                this.formRef.current.setFieldsValue(
                                                  {
                                                    expiryDate: dayjs().add(
                                                      1,
                                                      "year",
                                                    ),
                                                  },
                                                );
                                              }
                                            }}
                                          />
                                        </Form.Item>

                                        <Form.Item
                                          name="expiryDate"
                                          className="uploadCompany"
                                          label={this.context.translate(
                                            "_VEHICLE_EXPIRY_DATE_",
                                          )}
                                          rules={[{ type: Date }]}
                                          initialValue={dayjs().add(1, "years")}
                                        >
                                          <DatePicker
                                            style={{
                                              width: "100%",
                                              height: "40px",
                                            }}
                                            format="YYYY-MM-DD"
                                            disabled={
                                              this.state.disabledField ||
                                              !this.props.canUpdate(
                                                "waslexpirydate",
                                              )
                                            }
                                          />
                                        </Form.Item>
                                      </>
                                    )}
                                </Col>
                                <Col span={12}>
                                  {this.props.getUserData().isadmin !== 1 &&
                                    this.props.getUserData().isadmin !== 0 && (
                                      <>
                                        <Form.Item
                                          className="uploadCompany"
                                          name="installDate"
                                          label={
                                            <span>
                                              {this.context.translate(
                                                "_INSTALLATION_DATE_",
                                              )}{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </span>
                                          }
                                          required={false}
                                          rules={[
                                            {
                                              required: true,
                                              message: `${this.context.translate(
                                                "_INSTALLATION_DATE_",
                                              )} ${this.context.translate(
                                                "_IS_REQUIRED_",
                                              )}`,
                                            },
                                          ]}
                                          initialValue={dayjs()}
                                        >
                                          <DatePicker
                                            style={{
                                              width: "100%",
                                              height: "40px",
                                            }}
                                            format={dateFormat}
                                            disabled={this.state.disabledField}
                                          />
                                        </Form.Item>

                                        <Form.Item
                                          name="renewedAt"
                                          className="uploadCompany"
                                          label={this.context.translate(
                                            "_RENEWED_AT_",
                                          )}
                                        >
                                          <Input disabled />
                                        </Form.Item>
                                      </>
                                    )}
                                </Col>
                              </Row>
                            </VehicleTitleBox>
                          )}
                      </div>

                      <div className="formFooter">
                        <Button
                          className="formsCancelButton"
                          onClick={() => {
                            this.closeModal();
                          }}
                        >
                          {this.context.translate(
                            "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_",
                          )}
                        </Button>
                        <Button
                          onClick={(e) => {
                            this.handleNextClick();
                          }}
                          className="formsSaveButton"
                        >
                          {this.context.translate("_NEXT_")}
                        </Button>
                      </div>
                    </TabPane>

                    <TabPane
                      tab={
                        <span
                          className={
                            this.state.tabErrors["2"] && "validation-failed"
                          }
                        >
                          <Button
                            type="text"
                            style={{
                              background:
                                this.state.activeTab === "2"
                                  ? " rgba(255, 255, 255, 0.30)"
                                  : "rgb(7, 22, 61)",
                              border: "none",
                              borderRadius: "0px",
                            }}
                          >
                            {this.context.translate("_MAINTENANCE_DETAILS_")}
                          </Button>
                        </span>
                      }
                      key="2"
                    >
                      <div
                        style={{
                          overflowY: "scroll",
                          height: "90%",
                          paddingInlineStart: "20px",
                        }}
                      >
                        <VehicleTitleBox
                          title={this.context.translate("_ASSET_DOCUMENTS_")}
                        >
                          <Row gutter={16}>
                            <Col span={12}>
                              <Form.Item
                                className="uploadCompany"
                                name="mulkiyaRenewal"
                                label={this.context.translate(
                                  "_MULKIYA_RENEWAL_DATE_1",
                                )}
                                rules={[{ type: Date }]}
                              >
                                <DatePicker
                                  style={{ width: "100%", height: "40px" }}
                                  format={dateFormat}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="permitExpiryDate"
                                label={this.context.translate(
                                  "_PERMIT_EXPIRY_DATE_",
                                )}
                              >
                                <DatePicker
                                  format="YYYY-MM-DD"
                                  style={{ width: "100%", height: "40px" }}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="pollutionExpiryDate"
                                label={this.context.translate(
                                  "_POLLUTION_EXPIRY_DATE_",
                                )}
                                rules={[{ type: Date }]}
                              >
                                <DatePicker
                                  format="YYYY-MM-DD"
                                  style={{ width: "100%", height: "40px" }}
                                />
                              </Form.Item>

                              <Form.Item
                                name="minimumFineAmount"
                                label={this.context.translate(
                                  "_MIN_FINE_AMOUNT_",
                                )}
                                className="uploadCompany"
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                className="uploadCompany"
                                name="insuranceRenewal"
                                label={this.context.translate(
                                  "_INSURANCE_EXPIRY_DATE_",
                                )}
                                rules={[{ type: Date }]}
                              >
                                <DatePicker
                                  style={{ width: "100%", height: "40px" }}
                                  format={dateFormat}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="nationalPermitExpiryDate"
                                label={this.context.translate(
                                  "_NATIONAL_PERMIT_EXPIRY_DATE_",
                                )}
                                rules={[{ type: Date }]}
                              >
                                <DatePicker
                                  format="YYYY-MM-DD"
                                  style={{ width: "100%", height: "40px" }}
                                />
                              </Form.Item>

                              <Form.Item
                                name="finePerMinute"
                                label={this.context.translate(
                                  "_FINE_PER_MINUTE_",
                                )}
                                className="uploadCompany"
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                          </Row>
                        </VehicleTitleBox>

                        <VehicleTitleBox
                          title={this.context.translate("_ASSET_SERVICING_")}
                        >
                          <Row gutter={16}>
                            <Col span={12}>
                              <Form.Item
                                className="uploadCompany"
                                name="odometerReading"
                                label={this.context.translate(
                                  "_ASSET_ODOMETER_",
                                )}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "odometerReading",
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="serviceexpireKm"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_SERVICEEXPIRE_",
                                )}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "serviceexpireKm",
                                    )
                                  }
                                />
                              </Form.Item>
                              <Form.Item
                                className="uploadCompany"
                                name="lasttirechange"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_LASTTIRE_",
                                )}
                                rules={[{ type: Date }]}
                              >
                                <DatePicker
                                  style={{ width: "100%", height: "40px" }}
                                  format={dateFormat}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="lastservicedone"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_LASTSERVICE_",
                                )}
                                rules={[{ type: Date }]}
                              >
                                <DatePicker
                                  style={{ width: "100%", height: "40px" }}
                                  format={dateFormat}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="tirechangeKm"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_TIRECHANGE_",
                                )}
                              >
                                <Input
                                  placeholder={this.context.translate(
                                    "_FLEET_VEHICLE_VEHICLEDETAIL_TIRECHANGE_",
                                  )}
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "tirechangeKm",
                                    )
                                  }
                                />
                              </Form.Item>
                              <Form.Item
                                className="uploadCompany"
                                name="machineservicehours"
                                label={this.context.translate(
                                  "_EQUIPMENT_SERVICE_INTERVAL_",
                                )}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "machineservicehours",
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              {this.props.getUserData().isadmin == 0 ||
                                this.props.getUserData().isadmin == 1 ||
                                (!this.props.vehicleIdForEdit && (
                                  <Form.Item
                                    className="uploadCompany"
                                    name="diffOdo"
                                    label={this.context.translate(
                                      "_DIFFERANTIAL_ODOMETER_",
                                    )}
                                  >
                                    <Input
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "diffOdo",
                                        )
                                      }
                                    />
                                  </Form.Item>
                                ))}

                              <Form.Item
                                className="uploadCompany"
                                name="oilchangeKm"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_OILCHANGE_",
                                )}
                              >
                                <Input
                                  placeholder={this.context.translate(
                                    "_FLEET_VEHICLE_VEHICLEDETAIL_OILCHANGE_",
                                  )}
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "oilchangeKm",
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="lastoilchange"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_LASTOILCHANGE_",
                                )}
                                rules={[{ type: Date }]}
                              >
                                <DatePicker
                                  style={{ width: "100%", height: "40px" }}
                                  format={dateFormat}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="batteryExpire"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_BATTERY_CHANGE_INT_",
                                )}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "batteryExpire",
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                label={this.context.translate("_LAST_SERVICE_")}
                                name="lastServiceHours"
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                          </Row>
                        </VehicleTitleBox>
                      </div>
                      <div className="formFooter">
                        <Button
                          className="formsCancelButton"
                          style={{ marginInlineEnd: "10px" }}
                          onClick={() => {
                            this.setState({ showAlertModal: true });
                          }}
                        >
                          {this.context.translate("_FLEET_CLOSE_BTN_")}
                        </Button>
                        <Button
                          className="formsCancelButton"
                          onClick={() => {
                            this.handleBackClick();
                          }}
                        >
                          {this.context.translate(
                            "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_",
                          )}
                        </Button>
                        <Button
                          onClick={(e) => {
                            this.handleNextClick();
                          }}
                          className="formsSaveButton"
                        >
                          {this.context.translate("_NEXT_")}
                        </Button>
                      </div>
                    </TabPane>

                    <TabPane
                      tab={
                        <span
                          className={
                            this.state.tabErrors["3"] && "validation-failed"
                          }
                        >
                          <Button
                            type="text"
                            style={{
                              background:
                                this.state.activeTab === "3"
                                  ? " rgba(255, 255, 255, 0.30)"
                                  : "rgb(7, 22, 61)",
                              border: "none",
                              borderRadius: "0px",
                            }}
                          >
                            {this.context.translate("_PERIPHERALS_")}
                          </Button>
                        </span>
                      }
                      key="3"
                    >
                      <div
                        style={{
                          overflowY: "scroll",
                          height: "90%",
                          paddingInlineStart: "20px",
                        }}
                      >
                        <VehicleTitleBox
                          title={this.context.translate(
                            "_CONNECTED_PERIPHERALS_",
                          )}
                        >
                          <Row gutter={16}>
                            <Col span={12}>
                              {(Number(this.props.getUserData().isadmin) ===
                                -1 ||
                                Number(this.props.getUserData().isadmin) ===
                                  3) && (
                                <>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="addOn"
                                    label={this.context.translate("_ADDON_")}
                                  >
                                    <Checkbox
                                      checked={this.state.DriverId}
                                      onChange={(e) => {
                                        this.setState({
                                          DriverId: e.target.checked,
                                        });
                                      }}
                                    >
                                      {this.context.translate("_IBUTTONID_")}
                                    </Checkbox>

                                    <Checkbox
                                      value={4}
                                      checked={this.state.rfid}
                                      onChange={(e) => {
                                        this.setState({
                                          rfid: e.target.checked,
                                        });
                                      }}
                                    >
                                      {this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_RFID_",
                                      )}
                                    </Checkbox>

                                    <Checkbox
                                      checked={this.state.fuelSensor}
                                      onChange={(e) => {
                                        this.setState({
                                          fuelSensor: e.target.checked,
                                        });
                                      }}
                                    >
                                      {this.context.translate("_FUEL_SENSOR_")}
                                    </Checkbox>

                                    <Checkbox
                                      checked={this.state.temperatureSensor}
                                      onChange={(e) => {
                                        this.setState({
                                          temperatureSensor: e.target.checked,
                                        });
                                      }}
                                    >
                                      {this.context.translate(
                                        "_TEMPERATURE_SENSOR_",
                                      )}
                                    </Checkbox>
                                  </Form.Item>

                                  {this.state.fuelSensor && (
                                    <>
                                      {" "}
                                      <Form.Item
                                        className="uploadCompany"
                                        name="fuelId1"
                                        label={this.context.translate(
                                          "_FUEL_ID_1_",
                                        )}
                                      >
                                        <Input />
                                      </Form.Item>
                                      <Form.Item
                                        name="fuelId2"
                                        className="uploadCompany"
                                        label={this.context.translate(
                                          "_FUEL_ID_2_",
                                        )}
                                      >
                                        <Input />
                                      </Form.Item>
                                    </>
                                  )}
                                </>
                              )}

                              <Form.Item
                                className="uploadCompany"
                                name="tankvolume"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_TANKVOLUME_",
                                )}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "tankvolume",
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="tankshape1"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_TANK1SHAPE_",
                                )}
                              >
                                <Select
                                  placeholder={this.context.translate(
                                    "_SELECT_TANK_SHAPE_",
                                  )}
                                  onChange={(value) => {
                                    this.tankShape1(value);
                                  }}
                                  options={[
                                    {
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_HORIZONTAL_",
                                      ),
                                      value: "Horizontal Rectangle",
                                    },
                                    {
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_VERTICAL_",
                                      ),
                                      value: "Vertical Cylinder",
                                    },
                                    {
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_CYLINDRICAL_",
                                      ),
                                      value: "Horizontal Cylinder",
                                    },
                                  ]}
                                />
                              </Form.Item>
                              {this.state.horizontalrectangle && (
                                <>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="tanklength1"
                                    label={
                                      <label
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {this.context.translate(
                                          "_TANK_L_IN_CM_",
                                        )}
                                      </label>
                                    }
                                  >
                                    <Input
                                      placeholder={this.context.translate(
                                        "_LENGTH_",
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "tanklength1",
                                        )
                                      }
                                    />
                                  </Form.Item>

                                  <Form.Item
                                    className="uploadCompany"
                                    name="tankwidth1"
                                    label={
                                      <label
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {this.context.translate(
                                          "_TANK_W_IN_CM_",
                                        )}
                                      </label>
                                    }
                                  >
                                    <Input
                                      placeholder={this.context.translate(
                                        "_WIDTH_",
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "tankwidth1",
                                        )
                                      }
                                    />
                                  </Form.Item>

                                  <Form.Item
                                    className="uploadCompany"
                                    name="tankheight1"
                                    label={
                                      <label
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {this.context.translate(
                                          "_TANK_HEIGHT_IN_CM_",
                                        )}
                                      </label>
                                    }
                                  >
                                    <Input
                                      placeholder={this.context.translate(
                                        "_HEIGHT__",
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "tankheight1",
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </>
                              )}

                              {this.state.verticalcylinder && (
                                <>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="tanklength1"
                                    label={
                                      <label
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {this.context.translate(
                                          "_TANK1_l_IN_CM_",
                                        )}
                                      </label>
                                    }
                                  >
                                    <Input
                                      placeholder={this.context.translate(
                                        "_LENGTH_",
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "tanklength1",
                                        )
                                      }
                                    />
                                  </Form.Item>

                                  <Form.Item
                                    className="uploadCompany"
                                    name="tankdiameter1"
                                    label={
                                      <label
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {this.context.translate(
                                          "_TANK1_D_IN_CM_",
                                        )}
                                      </label>
                                    }
                                  >
                                    <Input
                                      placeholder={this.context.translate(
                                        "_DIAMETER_",
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "tankdiameter1",
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </>
                              )}

                              {this.state.horizontalcylinder && (
                                <>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="tanklength1"
                                    label={
                                      <label
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {this.context.translate(
                                          "_TANK1_l_IN_CM_",
                                        )}
                                      </label>
                                    }
                                  >
                                    <Input
                                      placeholder={this.context.translate(
                                        "_LENGTH_",
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "tanklength1",
                                        )
                                      }
                                    />
                                  </Form.Item>

                                  <Form.Item
                                    className="uploadCompany"
                                    name="tankdiameter1"
                                    label={
                                      <label
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {this.context.translate(
                                          "_TANK1_D_IN_CM_",
                                        )}
                                      </label>
                                    }
                                  >
                                    <Input
                                      placeholder={this.context.translate(
                                        "_DIAMETER_",
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "tankdiameter1",
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </>
                              )}

                              <Form.Item
                                className="uploadCompany"
                                name="fid1"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_FID1_",
                                )}
                              >
                                <Input
                                  placeholder="F Id 1"
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "fid1",
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="installationspace1"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_INSTALLATIONSPACE1_",
                                )}
                              >
                                <Input
                                  placeholder={this.context.translate(
                                    "_SPACE_1_CM_",
                                  )}
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "installationspace1",
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                name="isCanbus"
                                label=" "
                                valuePropName="checked"
                                style={{
                                  marginBottom: "38px",
                                  marginTop: "9px",
                                }}
                              >
                                <Checkbox>
                                  {this.context.translate("_CANBUS_")}
                                </Checkbox>
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="fuelCalibrationId"
                                label={this.context.translate(
                                  "_FUEL_CALIBRATION_",
                                )}
                              >
                                <Select
                                  options={this.vehicleStore?.fuelDetails}
                                  fieldNames={{
                                    label: "fuelCalibrationName",
                                    value: "Id",
                                  }}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="fuel"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_FUELTYPE_",
                                )}
                              >
                                <Select>
                                  <Select.Option value="Petrol">
                                    {this.context.translate(
                                      "_FLEET_VEHICLEDETAIL_FUELTYPEDDL_PETROL",
                                    )}
                                  </Select.Option>
                                  <Select.Option value="Diesel">
                                    {this.context.translate(
                                      "_FLEET_VEHICLEDETAIL_FUELTYPE_DIESEL_",
                                    )}
                                  </Select.Option>
                                </Select>
                              </Form.Item>

                              {this.state.temperatureSensor && (
                                <>
                                  <Form.Item
                                    name="tempId1"
                                    className="uploadCompany"
                                    label={this.context.translate("_TEMP_ID1_")}
                                  >
                                    <Select />
                                  </Form.Item>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="tempId2"
                                    label={this.context.translate("_TEMP_ID2_")}
                                  >
                                    <Select />
                                  </Form.Item>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="tempId3"
                                    label={this.context.translate("_TEMP_ID3_")}
                                  >
                                    <Select />
                                  </Form.Item>
                                </>
                              )}
                            </Col>
                          </Row>
                        </VehicleTitleBox>
                        {this.props.getUserData().isadmin !== 1 &&
                          this.props.getUserData().isadmin !== 0 && (
                            <VehicleTitleBox
                              title={this.context.translate("_INPUT_MAPPING_")}
                            >
                              <Row gutter={16}>
                                <Col span={12}>
                                  {this.props.getUserData().isadmin !== 1 &&
                                    this.props.getUserData().isadmin !== 0 && (
                                      <>
                                        <Form.Item
                                          className="uploadCompany"
                                          name="DigInpt1"
                                          // label=" DigiInput1:"
                                          label={this.context.translate(
                                            "_FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL1_",
                                          )}
                                        >
                                          <Select
                                            options={[
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_DOOR_",
                                                ),
                                                value: "Door",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_SEATBELT_",
                                                ),
                                                value: "Seatbelt",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_ACC_",
                                                ),
                                                value: "ACC",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_PANIC_",
                                                ),
                                                value: "Panic",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_PANIC_BACK_",
                                                  ),
                                                value: "PanicBack",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_AC_",
                                                ),
                                                value: "AC",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_SEAT_SENSORS_",
                                                  ),
                                                value: "Seatsensor",
                                              },
                                              ...(features.sweeper
                                                ? [
                                                    {
                                                      label:
                                                        this.context.translate(
                                                          "_LEFT_SWEEPER_",
                                                        ),
                                                      value: "Leftsweeper",
                                                    },
                                                    {
                                                      label:
                                                        this.context.translate(
                                                          "_RIGHT_SWEEPER_",
                                                        ),
                                                      value: "Rightsweeper",
                                                    },
                                                  ]
                                                : []),
                                            ]}
                                          />
                                        </Form.Item>

                                        <Form.Item
                                          className="uploadCompany"
                                          name="DigInpt2"
                                          label={this.context.translate(
                                            "_FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL2_",
                                          )}
                                        >
                                          <Select
                                            options={[
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_DOOR_",
                                                ),
                                                value: "Door",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_SEATBELT_",
                                                ),
                                                value: "Seatbelt",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_ACC_",
                                                ),
                                                value: "ACC",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_PANIC_",
                                                ),
                                                value: "Panic",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_PANIC_BACK_",
                                                  ),
                                                value: "PanicBack",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_AC_",
                                                ),
                                                value: "AC",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_SEAT_SENSORS_",
                                                  ),
                                                value: "Seatsensor",
                                              },
                                              ...(features.sweeper
                                                ? [
                                                    {
                                                      label:
                                                        this.context.translate(
                                                          "_LEFT_SWEEPER_",
                                                        ),
                                                      value: "Leftsweeper",
                                                    },
                                                    {
                                                      label:
                                                        this.context.translate(
                                                          "_RIGHT_SWEEPER_",
                                                        ),
                                                      value: "Rightsweeper",
                                                    },
                                                  ]
                                                : []),
                                            ]}
                                          />
                                        </Form.Item>

                                        <Form.Item
                                          className="uploadCompany"
                                          name="AngInpt1"
                                          label={this.context.translate(
                                            "_FLEET_DASHBORD_SETTING_FUELVOLUME1_",
                                          )}
                                        >
                                          <Select
                                            options={[
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_DOOR_",
                                                ),
                                                value: "Door",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_SEATBELT_",
                                                ),
                                                value: "Seatbelt",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_ACC_",
                                                ),
                                                value: "ACC",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_PANIC_",
                                                ),
                                                value: "Panic",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_AC_",
                                                ),
                                                value: "AC",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_SEAT_SENSORS_",
                                                  ),
                                                value: "Seatsensor",
                                              },
                                            ]}
                                          />
                                        </Form.Item>
                                        <Form.Item
                                          className="uploadCompany"
                                          name="AngInpt2"
                                          label={this.context.translate(
                                            "_FLEET_DASHBORD_SETTING_FUELVOLUME2_",
                                          )}
                                        >
                                          <Select
                                            options={[
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_DOOR_",
                                                ),
                                                value: "Door",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_SEATBELT_",
                                                ),
                                                value: "Seatbelt",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_ACC_",
                                                ),
                                                value: "ACC",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_PANIC_",
                                                ),
                                                value: "Panic",
                                              },

                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_AC_",
                                                ),
                                                value: "AC",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_SEAT_SENSORS_",
                                                  ),
                                                value: "Seatsensor",
                                              },
                                            ]}
                                          />
                                        </Form.Item>
                                      </>
                                    )}
                                </Col>
                                <Col span={12}>
                                  {this.props.getUserData().isadmin !== 1 &&
                                    this.props.getUserData().isadmin !== 0 && (
                                      <>
                                        {" "}
                                        <Form.Item
                                          className="uploadCompany"
                                          name="DigInpt3"
                                          label={this.context.translate(
                                            "_FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL3_",
                                          )}
                                        >
                                          <Select
                                            options={[
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_DOOR_",
                                                ),
                                                value: "Door",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_SEATBELT_",
                                                ),
                                                value: "Seatbelt",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_ACC_",
                                                ),
                                                value: "ACC",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_PANIC_",
                                                ),
                                                value: "Panic",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_PANIC_BACK_",
                                                  ),
                                                value: "PanicBack",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_AC_",
                                                ),
                                                value: "AC",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_SEAT_SENSORS_",
                                                  ),
                                                value: "Seatsensor",
                                              },
                                              ...(features.sweeper
                                                ? [
                                                    {
                                                      label:
                                                        this.context.translate(
                                                          "_LEFT_SWEEPER_",
                                                        ),
                                                      value: "Leftsweeper",
                                                    },
                                                    {
                                                      label:
                                                        this.context.translate(
                                                          "_RIGHT_SWEEPER_",
                                                        ),
                                                      value: "Rightsweeper",
                                                    },
                                                  ]
                                                : []),
                                            ]}
                                          />
                                        </Form.Item>
                                        <Form.Item
                                          className="uploadCompany"
                                          name="DigInpt4"
                                          label={this.context.translate(
                                            "_FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL4_",
                                          )}
                                        >
                                          <Select
                                            options={[
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_DOOR_",
                                                ),
                                                value: "Door",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_SEATBELT_",
                                                ),
                                                value: "Seatbelt",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_ACC_",
                                                ),
                                                value: "ACC",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_PANIC_",
                                                ),
                                                value: "Panic",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_PANIC_BACK_",
                                                  ),
                                                value: "PanicBack",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_AC_",
                                                ),
                                                value: "AC",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_SEAT_SENSORS_",
                                                  ),
                                                value: "Seatsensor",
                                              },
                                              ...(features.sweeper
                                                ? [
                                                    {
                                                      label:
                                                        this.context.translate(
                                                          "_LEFT_SWEEPER_",
                                                        ),
                                                      value: "Leftsweeper",
                                                    },
                                                    {
                                                      label:
                                                        this.context.translate(
                                                          "_RIGHT_SWEEPER_",
                                                        ),
                                                      value: "Rightsweeper",
                                                    },
                                                  ]
                                                : []),
                                            ]}
                                          />
                                        </Form.Item>
                                        <Form.Item
                                          className="uploadCompany"
                                          name="AngInpt3"
                                          label={this.context.translate(
                                            "_FLEET_DASHBORD_SETTING_FUELVOLUM3_",
                                          )}
                                        >
                                          <Select
                                            options={[
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_DOOR_",
                                                ),
                                                value: "Door",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_SEATBELT_",
                                                ),
                                                value: "Seatbelt",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_ACC_",
                                                ),
                                                value: "ACC",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_PANIC_",
                                                ),
                                                value: "Panic",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_AC_",
                                                ),
                                                value: "AC",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_SEAT_SENSORS_",
                                                  ),
                                                value: "Seatsensor",
                                              },
                                            ]}
                                          />
                                        </Form.Item>
                                        <Form.Item
                                          className="uploadCompany"
                                          name="AngInpt4"
                                          label={this.context.translate(
                                            "_FLEET_DASHBORD_SETTING_FUELVOLUME4_",
                                          )}
                                        >
                                          <Select
                                            options={[
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_DOOR_",
                                                ),
                                                value: "Door",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_SEATBELT_",
                                                ),
                                                value: "Seatbelt",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_ACC_",
                                                ),
                                                value: "ACC",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_PANIC_",
                                                ),
                                                value: "Panic",
                                              },
                                              {
                                                label: this.context.translate(
                                                  "_FLEET_DASHBORD_SETTING_AC_",
                                                ),
                                                value: "AC",
                                              },
                                              {
                                                label:
                                                  this.context.translate(
                                                    "_SEAT_SENSORS_",
                                                  ),
                                                value: "Seatsensor",
                                              },
                                            ]}
                                          />
                                        </Form.Item>
                                      </>
                                    )}
                                </Col>
                              </Row>
                            </VehicleTitleBox>
                          )}
                      </div>

                      <div className="formFooter">
                        <Button
                          className="formsCancelButton"
                          style={{ marginInlineEnd: "10px" }}
                          onClick={() => {
                            this.setState({ showAlertModal: true });
                          }}
                        >
                          {this.context.translate("_FLEET_CLOSE_BTN_")}
                        </Button>
                        <Button
                          className="formsCancelButton"
                          onClick={() => {
                            this.handleBackClick();
                          }}
                        >
                          {this.context.translate(
                            "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_",
                          )}
                        </Button>
                        <Button
                          loading={this.state.loading}
                          htmlType="submit"
                          className="formsSaveButton"
                        >
                          {this.context.translate("_SUBMIT_")}
                        </Button>
                      </div>
                    </TabPane>
                  </Tabs>
                </div>
              </Form>
            </Spin>
          </div>

          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openDriverDetailsForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_DRIVER_DETAILS_")}
                <p className="formDescription">
                  {this.context.translate("_DRIVER_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openDriverDetailsForm: false })}
            onCancel={() => this.setState({ openDriverDetailsForm: false })}
          >
            <div style={{ height: "100%" }}>
              <DriverAdd
                response={this.responseMsg}
                closeModal={this.closeDriverModal}
              ></DriverAdd>
            </div>
          </Drawer>

          <Drawer
            className="accountFormDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openSensorMappingForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            maskClosable={false}
            onOk={() => this.setState({ openSensorMappingForm: false })}
            onCancel={() => this.setState({ openSensorMappingForm: false })}
          >
            <div style={{ height: "100%" }}>
              <SensorMappingAdd
                key={this.state.sensorMappingId}
                sensorMappingId={this.state.sensorMappingId}
                companyId={this.state.companyId}
                plateNo={this.state.plateNo}
                isCopy={true}
                response={this.sensorMappingResponseMsg}
                closeModal={this.closeSensorMappingModal}
              ></SensorMappingAdd>
            </div>
          </Drawer>

          {this.state.showAlertModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="deleteModalTitle">
                  <span> {this.context.translate("_FLEET_ALERT_")}</span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ showAlertModal: false })}
                  />
                </div>
              }
              className="deleteModal"
              description="Alert"
              centered
              open={this.state.showAlertModal}
              footer={null}
              width={400}
              closable={false}
              style={{ left: "510px" }}
            >
              <div className="deleteModalText">
                <p>{this.context.translate("_ALERT_CLOSE_BUTTON_MESSAGE_")}</p>
              </div>
              <div>
                <Button
                  className="deleteModalCancelButton"
                  onClick={() => {
                    this.setState({ showAlertModal: false });
                    this.closeModal();
                  }}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_",
                  )}
                </Button>
              </div>
            </Modal>
          )}
        </div>
      </>
    );
  }
}

VehicleAdd2.contextType = StoreContext;
export default observer(withRouter(VehicleAdd2));
